(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("best-city", [], factory);
	else if(typeof exports === 'object')
		exports["best-city"] = factory();
	else
		root["best-city"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(19)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_view_vue__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BestCity',
  components: {
    'city-view': __WEBPACK_IMPORTED_MODULE_0__view_view_vue__["a" /* default */]
  },
  props: {
    // 是否可以使用拼音（若没拼音这个属性需要设置为false
    canSearchSpell: {
      type: Boolean,
      default: true
    },
    location: {
      type: Object,
      default: function _default() {
        return {
          acronym: 'bj',
          firstChar: 'B',
          id: 1,
          name: '北京',
          pinyin: 'beijing',
          rank: 'S'
        };
      }
    },
    slide: {
      type: String,
      default: 'vertical' // horizontal
    },
    backStyle: {
      type: String,
      default: 'retreat' // cross/retreat/tilted/fold/return
    }
  },
  data: function data() {
    return {
      showStatus: false
    };
  },

  computed: {
    slideStyle: function slideStyle() {
      return this.slide === 'horizontal' ? 'horizontalSide' : 'verticalSide';
    }
  },
  methods: {
    show: function show() {
      this.showStatus = true;
    },
    hide: function hide() {
      this.showStatus = false;
    },
    closeChooseCity: function closeChooseCity(res) {
      this.$emit('closeChooseCity', res);
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Search__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Scroll_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PositionBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CityList__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NavList__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MaskBox__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SearchList__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_js_search__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_js_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_js_cityData__ = __webpack_require__(56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    name: "VueCity",
    components: {
        search: __WEBPACK_IMPORTED_MODULE_0__components_Search__["a" /* default */],
        scroll: __WEBPACK_IMPORTED_MODULE_1__components_Scroll_vue__["a" /* default */],
        "position-box": __WEBPACK_IMPORTED_MODULE_2__components_PositionBox__["a" /* default */],
        "nav-list": __WEBPACK_IMPORTED_MODULE_4__components_NavList__["a" /* default */],
        "city-list": __WEBPACK_IMPORTED_MODULE_3__components_CityList__["a" /* default */],
        "mask-box": __WEBPACK_IMPORTED_MODULE_5__components_MaskBox__["a" /* default */],
        "search-list": __WEBPACK_IMPORTED_MODULE_6__components_SearchList__["a" /* default */]
    },
    props: {
        // 是否可以使用拼音（若没拼音这个属性需要设置为false
        canSearchSpell: {
            type: Boolean,
            default: true
        },
        location: {
            type: Object,
            default: function _default() {
                return {
                    cityCode: "110000",
                    cityName: "北京市",
                    provinceCode: "110000",
                    provinceName: "北京市",
                    id: "1130734065938939906",
                    countyCode: null,
                    regionNamePinyin: "beijingshi",
                    regionNameInitial: "B"
                };
            }
        },
        hide: {
            type: Function,
            default: null
        },
        backStyle: {
            type: String,
            default: "retreat" // cross/retreat/tilted/fold/return
        }
    },
    data: function data() {
        return {
            chooseCityName: null, // 选择查看的城市
            citylist: __WEBPACK_IMPORTED_MODULE_9__common_js_cityData__["b" /* openCityList */], // 城市列表
            hotCity: __WEBPACK_IMPORTED_MODULE_9__common_js_cityData__["a" /* hotCityList */], //热门城市
            cityIndexList: ["顶"], // 右边导航栏列表
            maskShow: false, // 弹窗是否弹出
            maskMessage: "", // 弹窗展示的信息
            associationShow: false, // 是否开启联想展示框
            searchListContent: [], // 搜索页的内容数组
            clearSearch: false, // 是否清除输入框的文字
            elementIndex: "", // navlist页点击的index
            arrHeight: [], // 高度数组
            flag: false, // 字母牌是否显示
            flagText: "顶" // 字母牌显示的字
        };
    },
    computed: {
        backIcon: function backIcon() {
            switch (true) {
                case this.backStyle === "cross":
                    return "icon-guanbi";
                    break;
                case this.backStyle === "tilted":
                    return "icon-fanhui2";
                    break;
                case this.backStyle === "fold":
                    return "icon-fanhui1";
                    break;
                case this.backStyle === "return":
                    return "icon-fanhui";
                    break;
                default:
                    return "icon-fanhui3";
            }
        }
    },
    created: function created() {
        this.getCityListApi();
        console.log("hotcity", this.hotCity);
    },

    methods: {
        // 获取城市列表
        getCityListApi: function getCityListApi() {
            var arr = this.citylist.map(function (item) {
                return item[0];
            });
            this.cityIndexList = this.cityIndexList.concat(arr);
            this.getDomHeight();
        },

        // 搜索框内容
        searchText: function searchText(text) {
            if (text.length === 0) {
                this.associationShow = false;
                return false;
            }
            this.clearSearch = false;
            this.associationShow = true;
            this.searchListContent = Object(__WEBPACK_IMPORTED_MODULE_7__common_js_search__["a" /* getSearchList */])(text, this.citylist, this.canSearchSpell);
        },

        // 点击城市名字，弹出弹窗确认
        changeCity: function changeCity(city) {
            if (this.chooseCityName !== null && this.chooseCityName.name === city.name) {
                // 关闭搜索框（在搜索状态下）
                this.associationShow = false;
                // 清除输入框的字（在搜索状态下）
                this.clearSearch = true;
                return false;
            }
            // // 选择的城市的名字
            // this.maskMessage = city;
            // this.maskShow = true;

            console.error("city=========>", city);

            this.mapBack(city);
        },

        // 关闭确认弹窗
        maskClose: function maskClose() {
            this.maskShow = false;
        },

        // 关闭组件
        mapBack: function mapBack(res) {
            this.hide();
            this.$emit("closeChooseCity", res);
        },

        // 是否确认切换定位
        chooseResult: function chooseResult(res) {
            if (this.maskMessage) {
                this.chooseCityName = this.maskMessage;
                // 关闭搜索框（在搜索状态下）
                this.associationShow = false;
                // 清除输入框的字（在搜索状态下）
                this.clearSearch = true;
                // 当确认后滚动到顶部
                this.$refs.suggest.scrollTo(0, 0, 200);
                // this.maskClose();
                this.mapBack(res);
            } else {
                // 不切换，仅关闭弹窗
                this.maskClose();
            }
        },

        // 点击右边nav，向citylist组件传值
        toElement: function toElement(text) {
            if (text === "顶") {
                this.$refs.suggest.scrollToElement(this.$refs.positionBox, 300, false, 0);
            }
            this.elementIndex = text;
        },

        // 滚动到相应的dom节点
        singleLetter: function singleLetter(dom) {
            var titleHeight = document.querySelector("#vuecity .lists .city-title").offsetHeight;
            this.$refs.suggest.scrollToElement(dom, 300, false, titleHeight);
        },

        // 根据滑动距离显示字母牌上的字
        distance: function distance(val) {
            this.elementIndex = "";
            var index = this.arrHeight.findIndex(function (item) {
                return val < item;
            });
            index = index === -1 ? this.arrHeight.length - 1 : index;
            this.flagText = this.cityIndexList[index];
        },

        // 计算每一部分到顶端的距离
        getDomHeight: function getDomHeight() {
            var _this = this;

            this.$nextTick(function () {
                var titleHeight = document.querySelector("#vuecity .lists .city-title").offsetHeight;
                var itemHeight = document.querySelector("#vuecity .lists .city-item").offsetHeight;
                var positionboxHeight = document.querySelector("#vuecity .position-box").offsetHeight;
                var arr = Object(__WEBPACK_IMPORTED_MODULE_8__common_js_dom__["a" /* getDistance */])(_this.citylist, titleHeight, itemHeight);
                arr.unshift(positionboxHeight);
                var i = 0;
                arr.forEach(function (val) {
                    i = i + val;
                    _this.arrHeight.push(i);
                });
            });
        },

        // 是否显示字母牌
        scrollStore: function scrollStore(val) {
            this.flag = val;
            if (!val) {
                // 兼容better-scroll的bug
                this.distance(-1 * this.$refs.suggest.scroll.y);
            }
        }
    }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Search",
    props: {
        clearText: Boolean,
        canSearchSpell: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            searchText: "",
            timer: {}
        };
    },

    computed: {
        placeholderTxt: function placeholderTxt() {
            return this.canSearchSpell ? "城市名/拼音" : "请输入城市名";
        }
    },
    watch: {
        // 清除搜索内容
        clearText: function clearText(val) {
            if (val) {
                this.searchText = "";
                this.entry();
            }
        }
    },
    methods: {
        formSubmit: function formSubmit() {
            this.$emit("txtdata", this.searchText);
        },

        // 延时搜索
        entry: function entry() {
            var _this = this;

            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function () {
                _this.$emit("txtdata", _this.searchText);
            }, 300);
        }
    }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Scroll_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_48c22758_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Scroll_vue__ = __webpack_require__(30);
function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48c22758"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Scroll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_48c22758_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Scroll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll__ = __webpack_require__(29);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        data: {
            type: Array,
            default: null
        },
        // 是否触发滚动时间
        probeType: {
            type: Number,
            default: 1
        },
        // 是否监听滚动事件
        listenScroll: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        data: function data(val) {
            var _this = this;

            this.$nextTick(function () {
                return _this.refresh();
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        // // 保证在DOM渲染完毕后初始化better-scroll
        this.$nextTick(function () {
            return _this2._initScroll();
        });
    },

    methods: {
        _initScroll: function _initScroll() {
            var _this3 = this;

            if (!this.$refs.wrapper) {
                return;
            }
            this.scroll = new __WEBPACK_IMPORTED_MODULE_0_better_scroll__["a" /* default */](this.$refs.wrapper, {
                probeType: this.probeType,
                scrollY: true, // 滚动方向为Y轴
                click: true, // 是否派发click事件，通常判断浏览器派发的click还是betterscroll派发的click，可以用event._constructed，若是bs派发的则为true
                momentum: true, // 当快速滑动时是否开启滑动惯性
                bounce: false, // 是否启用回弹动画效果
                bounceTime: 700, // 弹力动画持续的毫秒数
                deceleration: 0.001, // 滚动动量减速越大越快，建议不大于0.01
                momentumLimitTime: 300, // 符合惯性拖动的最大时间
                momentumLimitDistance: 15, // 符合惯性拖动的最小拖动距离
                resizePolling: 60 // 重新调整窗口大小时，重新计算better-scroll的时间间隔
            });
            // 监听scroll事件
            if (this.listenScroll) {
                // 滚动开始时触发
                this.scroll.on("scrollStart", function () {
                    return _this3.$emit("scrollStore", true);
                });
                // pos为位置参数
                this.scroll.on("scroll", function (pos) {
                    _this3.$emit("distance", Math.abs(pos.y));
                    _this3.$emit("scrollStore", true);
                });
                // 滚动结束
                this.scroll.on("scrollEnd", function (val) {
                    _this3.$emit("scrollStore", false);
                });
            }
        },

        // 滚向位置
        scrollTo: function scrollTo() {
            this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
        },

        // 滚向元素
        scrollToElement: function scrollToElement() {
            this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
        },

        // 确保绑定成功
        refresh: function refresh() {
            this.scroll && this.scroll.refresh();
        }
    }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "PositionBox",
    props: {
        location: {
            type: Object,
            default: function _default() {
                return {
                    cityName: "北京",
                    cityCode: "110000"
                };
            }
        }
    },
    methods: {
        changeCity: function changeCity(city) {
            this.$emit("changeCity", city);
        }
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "CityList",
    props: {
        citylist: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        hotCityList: {
            type: Array
        },
        elementIndex: {
            type: String,
            default: ""
        }
    },
    mounted: function mounted() {
        console.log("xxxxxxxxxxxxxxxxxxxx", this.hotCitylist);
    },

    watch: {
        elementIndex: function elementIndex(val) {
            if (!val) return;
            if (val === "顶") return;
            this.$emit("singleLetter", this.$refs[val][0]);
        }
    },
    methods: {
        changeCity: function changeCity(city) {
            this.$emit("positionCity", city);
        }
    }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_dom__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "NavList",
    props: {
        navList: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        flagText: {
            type: String,
            default: ""
        }
    },
    data: function data() {
        return {
            touch: {
                start: 0,
                startIndex: "",
                end: 0,
                endIndex: ""
            },
            isTouch: false,
            itemHight: 20,
            paddingTop: 10
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.itemHight = document.querySelector(".navList .navItem").offsetHeight;
            _this.paddingTop = parseInt(getComputedStyle(document.querySelector("#vuecity .navbody"), false).paddingTop, 10);
        });
    },

    methods: {
        // 根据不同的状况赋值不同的样式
        navClass: function navClass(item) {
            if (this.isTouch) {
                return this.navList[this.touch.endIndex] === item ? "flagItem" : "navItem";
            } else {
                return this.flagText === item ? "flagItem" : "navItem";
            }
        },

        // 向上触发scroll滚动事件
        scrollToElement: function scrollToElement(item) {
            this.$emit("toElement", item);
        },

        // 触摸开始，并向上触发滚动事件
        start: function start(e) {
            this.isTouch = false;
            var item = Object(__WEBPACK_IMPORTED_MODULE_0__common_js_dom__["c" /* handleDomData */])(e.target, "data-name");
            this.touch.start = e.touches[0].pageY;
            this.touch.startIndex = Object(__WEBPACK_IMPORTED_MODULE_0__common_js_dom__["b" /* getIndex */])(this.navList, item);
            this.scrollToElement(item);
        },

        // 触摸过程中，根据距离变化应计算滚动到的位置
        move: function move(e) {
            this.isTouch = true;
            this.touch.end = e.touches[0].pageY;
            var distance = this.touch.end - this.touch.start;
            this.touch.endIndex = Math.min(Math.max(this.touch.startIndex + Math.floor((distance + this.paddingTop) / this.itemHight), 0), this.navList.length - 1);
            this.scrollToElement(this.navList[this.touch.endIndex]);
        },
        end: function end() {
            this.isTouch = false;
        }
    }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleDomData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIndex; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getDistance;
// 获取或者给dom属性赋值
var handleDomData = function handleDomData(el, name, val) {
  return val ? el.setAttribute(name, val) : el.getAttribute(name);
};

// 获取每一个字母在数组中对应的index
var getIndex = function getIndex(arr, query) {
  return arr.findIndex(function (val) {
    return val === query;
  });
};

// 计算链接每一部分的高度
function getDistance(arr, titleHeight, itemHeight) {
  var distanceArr = [];
  arr.forEach(function (item) {
    distanceArr.push(titleHeight + itemHeight * item[1].length - 1);
  });
  return distanceArr;
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "MaskBox",
    props: {
        message: {
            type: Object,
            default: function _default() {
                return { name: "", id: "" };
            }
        }
    },
    methods: {
        chooseTrue: function chooseTrue() {
            this.$emit("chooseing", this.message);
        },
        chooseFalse: function chooseFalse() {
            this.$emit("chooseing", null);
        }
    }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Scroll_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CityItem_vue__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchList',
  components: {
    'scroll': __WEBPACK_IMPORTED_MODULE_0__Scroll_vue__["a" /* default */],
    'city-item': __WEBPACK_IMPORTED_MODULE_1__CityItem_vue__["a" /* default */]
  },
  props: {
    searchListContent: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    // 点击列表触发改变定位的事件
    changeCity: function changeCity(name) {
      this.$emit('changeName', name);
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "CityItem",
    props: {
        searchListContent: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    methods: {
        changeCity: function changeCity(city) {
            this.$emit("changeName", city);
        }
    }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__packages_BestCity_vue__ = __webpack_require__(16);


__WEBPACK_IMPORTED_MODULE_0__packages_BestCity_vue__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__packages_BestCity_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__packages_BestCity_vue__["a" /* default */]);
};

// 导出模块
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__packages_BestCity_vue__["a" /* default */]);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_BestCity_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_445e4c53_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_BestCity_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_BestCity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_445e4c53_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_BestCity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(18);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("434f53f6", content, true, {});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports
exports.push([module.i, "@import url(https://at.alicdn.com/t/font_1125658_wv3sr6cqm8f.css);", ""]);

// module
exports.push([module.i, "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,html,i,iframe,img,input,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:100%;font-weight:400;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,menu,nav,section{display:block}body{line-height:1}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:none}table{border-collapse:collapse;border-spacing:0}a{color:#7e8c8d;-webkit-backface-visibility:hidden;text-decoration:none}li{list-style:none}body{-webkit-text-size-adjust:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.horizontalSide-enter-active,.horizontalSide-leave-active,.verticalSide-enter-active,.verticalSide-leave-active{transition:all .2s ease}.horizontalSide-enter,.horizontalSide-leave-to{transform:translateX(100%)}.verticalSide-enter,.verticalSide-leave-to{transform:translateY(-100%)}", ""]);

// exports


/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2c20bd22_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_view_vue__ = __webpack_require__(57);
function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c20bd22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2c20bd22_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(22);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1992a02c", content, true, {});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "p[data-v-2c20bd22]{text-align:start}#vuecity[data-v-2c20bd22]{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50;height:100%;width:100%;font-size:14px;position:absolute;top:0;left:0;z-index:1000000000000}#vuecity .pattern-box[data-v-2c20bd22]{width:100%;height:2.25rem;background:#fff;display:flex;flex-direction:row;align-items:center}#vuecity .pattern-box .mapBack[data-v-2c20bd22]{display:block;width:1.5rem;height:100%;line-height:2.25rem;margin-left:.4rem}#vuecity .pattern-box .search-box[data-v-2c20bd22]{height:100%;flex:1}#vuecity .nowFlag[data-v-2c20bd22]{width:50px;height:50px;background:rgba(0,0,0,.5);color:#fff;font-size:30px;font-weight:900;line-height:50px;text-align:center;position:absolute;top:50%;left:50%;margin-left:-25px}.list-enter-active[data-v-2c20bd22],.list-leave-active[data-v-2c20bd22]{transition:all .5s}.list-enter[data-v-2c20bd22]{opacity:0}.list-leave-to[data-v-2c20bd22]{transform:scale(0);opacity:0}.flag-leave-active[data-v-2c20bd22]{transition:all 1s}.flag-leave-to[data-v-2c20bd22]{opacity:0}", ""]);

// exports


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_656c702b_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(26);
function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-656c702b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_656c702b_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(25);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("570e3a6e", content, true, {});

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".search-box[data-v-656c702b]{height:100%;width:50%;margin:0 auto;background:#fff;display:flex;flex-direction:column;justify-content:center;align-items:center}.search-box>.ipt-box[data-v-656c702b]{width:95%;position:relative;height:30px;border-radius:15px;background:#f6f6f6;padding-top:7px;box-sizing:border-box}.searchInput[data-v-656c702b]{display:block;width:100%;padding-left:30%;padding-right:15%;border:none;outline:none;border-radius:20px;box-sizing:border-box;font-size:13px;background:#f6f6f6;line-height:18px;height:18px}input[data-v-656c702b]::-webkit-clear{display:none}.search-box>.ipt-box>.icon-box[data-v-656c702b]{left:30%;margin-left:-20px}.search-box>.ipt-box>.icon-box[data-v-656c702b],.search-box>.ipt-box>.mask-box[data-v-656c702b]{position:absolute;top:0;z-index:50;width:16px;height:30px;line-height:30px;display:flex;flex-direction:row;justify-content:center;align-items:center}.search-box>.ipt-box>.mask-box[data-v-656c702b]{right:15%;margin-right:-5px;background:#f6f6f6}.search-box>.ipt-box>.icon-box>.icon[data-v-656c702b]{font-size:20px;font-weight:900}", ""]);

// exports


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-box"},[_c('div',{staticClass:"ipt-box"},[_c('form',{attrs:{"action":"javascript:return true"},on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"searchInput",attrs:{"type":"search","placeholder":_vm.placeholderTxt},domProps:{"value":(_vm.searchText)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value},function($event){return _vm.entry()}]}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mask-box"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-box"},[_c('i',{staticClass:"iconfont icon-sousuo icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(28);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0f6b2d6f", content, true, {});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".scroll[data-v-48c22758]{height:100%;width:100%;overflow:hidden;background:#f6f6f6}", ""]);

// exports


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * better-normal-scroll v1.15.2
 * (c) 2016-2019 ustbhuangyi
 * Released under the MIT License.
 */
// As of V8 6.6, depending on the size of the array, this is anywhere
// between 1.5-10x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (; index + 1 < list.length; index++) {
    list[index] = list[index + 1];
  }

  list.pop();
}

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function eventMixin(BScroll) {
  BScroll.prototype.on = function (type, fn) {
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

    if (!this._events[type]) {
      this._events[type] = [];
    }

    this._events[type].push([fn, context]);
  };

  BScroll.prototype.once = function (type, fn) {
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

    function magic() {
      this.off(type, magic);

      fn.apply(context, arguments);
    }
    // To expose the corresponding function method in order to execute the off method
    magic.fn = fn;

    this.on(type, magic);
  };

  BScroll.prototype.off = function (type, fn) {
    var _events = this._events[type];
    if (!_events) {
      return;
    }

    var count = _events.length;
    while (count--) {
      if (_events[count][0] === fn || _events[count][0] && _events[count][0].fn === fn) {
        spliceOne(_events, count);
      }
    }
  };

  BScroll.prototype.trigger = function (type) {
    var events = this._events[type];
    if (!events) {
      return;
    }

    var len = events.length;
    var eventsCopy = [].concat(toConsumableArray(events));
    for (var i = 0; i < len; i++) {
      var event = eventsCopy[i];

      var _event = slicedToArray(event, 2),
          fn = _event[0],
          context = _event[1];

      if (fn) {
        fn.apply(context, [].slice.call(arguments, 1));
      }
    }
  };
}

// ssr support
var inBrowser = typeof window !== 'undefined';
var ua = inBrowser && navigator.userAgent.toLowerCase();
var isWeChatDevTools = ua && /wechatdevtools/.test(ua);
var isAndroid = ua && ua.indexOf('android') > 0;

function getNow() {
  return window.performance && window.performance.now ? window.performance.now() + window.performance.timing.navigationStart : +new Date();
}

function extend(target) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  for (var i = 0; i < rest.length; i++) {
    var source = rest[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}

function isUndef(v) {
  return v === undefined || v === null;
}

function getDistance(x, y) {
  return Math.sqrt(x * x + y * y);
}

var elementStyle = inBrowser && document.createElement('div').style;

var vendor = function () {
  if (!inBrowser) {
    return false;
  }
  // first pick up standard to fix #743
  var transformNames = {
    standard: 'transform',
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform'
  };

  for (var key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key;
    }
  }

  return false;
}();

function prefixStyle(style) {
  if (vendor === false) {
    return false;
  }

  if (vendor === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend';
    }
    return style;
  }

  return vendor + style.charAt(0).toUpperCase() + style.substr(1);
}

function addEvent(el, type, fn, capture) {
  el.addEventListener(type, fn, { passive: false, capture: !!capture });
}

function removeEvent(el, type, fn, capture) {
  el.removeEventListener(type, fn, { passive: false, capture: !!capture });
}

function offset(el) {
  var left = 0;
  var top = 0;

  while (el) {
    left -= el.offsetLeft;
    top -= el.offsetTop;
    el = el.offsetParent;
  }

  return {
    left: left,
    top: top
  };
}

function offsetToBody(el) {
  var rect = el.getBoundingClientRect();

  return {
    left: -(rect.left + window.pageXOffset),
    top: -(rect.top + window.pageYOffset)
  };
}

var cssVendor = vendor && vendor !== 'standard' ? '-' + vendor.toLowerCase() + '-' : '';

var transform = prefixStyle('transform');
var transition = prefixStyle('transition');

var hasPerspective = inBrowser && prefixStyle('perspective') in elementStyle;
// fix issue #361
var hasTouch = inBrowser && ('ontouchstart' in window || isWeChatDevTools);
var hasTransform = transform !== false;
var hasTransition = inBrowser && transition in elementStyle;

var style = {
  transform: transform,
  transition: transition,
  transitionTimingFunction: prefixStyle('transitionTimingFunction'),
  transitionDuration: prefixStyle('transitionDuration'),
  transitionDelay: prefixStyle('transitionDelay'),
  transformOrigin: prefixStyle('transformOrigin'),
  transitionEnd: prefixStyle('transitionEnd')
};

var TOUCH_EVENT = 1;
var MOUSE_EVENT = 2;

var eventType = {
  touchstart: TOUCH_EVENT,
  touchmove: TOUCH_EVENT,
  touchend: TOUCH_EVENT,

  mousedown: MOUSE_EVENT,
  mousemove: MOUSE_EVENT,
  mouseup: MOUSE_EVENT
};

function getRect(el) {
  if (el instanceof window.SVGElement) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  } else {
    return {
      top: el.offsetTop,
      left: el.offsetLeft,
      width: el.offsetWidth,
      height: el.offsetHeight
    };
  }
}

function preventDefaultException(el, exceptions) {
  for (var i in exceptions) {
    if (exceptions[i].test(el[i])) {
      return true;
    }
  }
  return false;
}

function tap(e, eventName) {
  var ev = document.createEvent('Event');
  ev.initEvent(eventName, true, true);
  ev.pageX = e.pageX;
  ev.pageY = e.pageY;
  e.target.dispatchEvent(ev);
}

function click(e) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'click';

  var eventSource = void 0;
  if (e.type === 'mouseup' || e.type === 'mousecancel') {
    eventSource = e;
  } else if (e.type === 'touchend' || e.type === 'touchcancel') {
    eventSource = e.changedTouches[0];
  }
  var posSrc = {};
  if (eventSource) {
    posSrc.screenX = eventSource.screenX || 0;
    posSrc.screenY = eventSource.screenY || 0;
    posSrc.clientX = eventSource.clientX || 0;
    posSrc.clientY = eventSource.clientY || 0;
  }
  var ev = void 0;
  var bubbles = true;
  var cancelable = true;
  if (typeof MouseEvent !== 'undefined') {
    try {
      ev = new MouseEvent(event, extend({
        bubbles: bubbles,
        cancelable: cancelable
      }, posSrc));
    } catch (e) {
      createEvent();
    }
  } else {
    createEvent();
  }

  function createEvent() {
    ev = document.createEvent('Event');
    ev.initEvent(event, bubbles, cancelable);
    extend(ev, posSrc);
  }

  // forwardedTouchEvent set to true in case of the conflict with fastclick
  ev.forwardedTouchEvent = true;
  ev._constructed = true;
  e.target.dispatchEvent(ev);
}

function dblclick(e) {
  click(e, 'dblclick');
}

function prepend(el, target) {
  if (target.firstChild) {
    before(el, target.firstChild);
  } else {
    target.appendChild(el);
  }
}

function before(el, target) {
  target.parentNode.insertBefore(el, target);
}

function removeChild(el, child) {
  el.removeChild(child);
}

var DEFAULT_OPTIONS = {
  startX: 0,
  startY: 0,
  scrollX: false,
  scrollY: true,
  freeScroll: false,
  directionLockThreshold: 5,
  eventPassthrough: '',
  click: false,
  tap: false,
  /**
   * support any side
   * bounce: {
   *   top: true,
   *   bottom: true,
   *   left: true,
   *   right: true
   * }
   */
  bounce: true,
  bounceTime: 800,
  momentum: true,
  momentumLimitTime: 300,
  momentumLimitDistance: 15,
  swipeTime: 2500,
  swipeBounceTime: 500,
  deceleration: 0.0015,
  flickLimitTime: 200,
  flickLimitDistance: 100,
  resizePolling: 60,
  probeType: 0,
  preventDefault: true,
  preventDefaultException: {
    tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|AUDIO)$/
  },
  HWCompositing: true,
  useTransition: true,
  useTransform: true,
  bindToWrapper: false,
  disableMouse: hasTouch,
  disableTouch: !hasTouch,
  observeDOM: true,
  autoBlur: true,
  /**
   * for picker
   * wheel: {
   *   selectedIndex: 0,
   *   rotate: 25,
   *   adjustTime: 400
   *   wheelWrapperClass: 'wheel-scroll',
   *   wheelItemClass: 'wheel-item'
   * }
   */
  wheel: false,
  /**
   * for slide
   * snap: {
   *   loop: false,
   *   el: domEl,
   *   threshold: 0.1,
   *   stepX: 100,
   *   stepY: 100,
   *   speed: 400,
   *   easing: {
   *     style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
   *     fn: function (t) {
   *       return t * (2 - t)
   *     }
   *   }
   *   listenFlick: true
   * }
   */
  snap: false,
  /**
   * for scrollbar
   * scrollbar: {
   *   fade: true,
   *   interactive: false
   * }
   */
  scrollbar: false,
  /**
   * for pull down and refresh
   * pullDownRefresh: {
   *   threshold: 50,
   *   stop: 20
   * }
   */
  pullDownRefresh: false,
  /**
   * for pull up and load
   * pullUpLoad: {
   *   threshold: 50
   * }
   */
  pullUpLoad: false,
  /**
   * for mouse wheel
   * mouseWheel: {
   *   speed: 20,
   *   invert: false,
   *   easeTime: 300
   * }
   */
  mouseWheel: false,
  stopPropagation: false,
  /**
   * for zoom
   * zoom: {
   *   start: 1,
   *   min: 1,
   *   max: 4
   * }
   */
  zoom: false,
  /**
   * for infinity
   * infinity: {
   *   render(item, div) {
   *   },
   *   createTombstone() {
   *   },
   *   fetch(count) {
   *   }
   * }
   */
  infinity: false,
  /**
   * for double click
   * dblclick: {
   *   delay: 300
   * }
   */
  dblclick: false
};

function initMixin(BScroll) {
  BScroll.prototype._init = function (options) {
    this._handleOptions(options);

    // init private custom events
    this._events = {};

    this.x = 0;
    this.y = 0;
    this.directionX = 0;
    this.directionY = 0;

    this.setScale(1);

    this._addDOMEvents();

    this._initExtFeatures();

    this._watchTransition();

    if (this.options.observeDOM) {
      this._initDOMObserver();
    }

    if (this.options.autoBlur) {
      this._handleAutoBlur();
    }

    this.refresh();

    if (!this.options.snap) {
      this.scrollTo(this.options.startX, this.options.startY);
    }

    this.enable();
  };

  BScroll.prototype.setScale = function (scale) {
    this.lastScale = isUndef(this.scale) ? scale : this.scale;
    this.scale = scale;
  };

  BScroll.prototype._handleOptions = function (options) {
    this.options = extend({}, DEFAULT_OPTIONS, options);

    this.translateZ = this.options.HWCompositing && hasPerspective ? ' translateZ(0)' : '';

    this.options.useTransition = this.options.useTransition && hasTransition;
    this.options.useTransform = this.options.useTransform && hasTransform;

    this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

    // If you want eventPassthrough I have to lock one of the axes
    this.options.scrollX = this.options.eventPassthrough === 'horizontal' ? false : this.options.scrollX;
    this.options.scrollY = this.options.eventPassthrough === 'vertical' ? false : this.options.scrollY;

    // With eventPassthrough we also need lockDirection mechanism
    this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
    this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

    if (this.options.tap === true) {
      this.options.tap = 'tap';
    }
  };

  BScroll.prototype._addDOMEvents = function () {
    var eventOperation = addEvent;
    this._handleDOMEvents(eventOperation);
  };

  BScroll.prototype._removeDOMEvents = function () {
    var eventOperation = removeEvent;
    this._handleDOMEvents(eventOperation);
  };

  BScroll.prototype._handleDOMEvents = function (eventOperation) {
    var target = this.options.bindToWrapper ? this.wrapper : window;
    eventOperation(window, 'orientationchange', this);
    eventOperation(window, 'resize', this);

    if (this.options.click) {
      eventOperation(this.wrapper, 'click', this, true);
    }

    if (!this.options.disableMouse) {
      eventOperation(this.wrapper, 'mousedown', this);
      eventOperation(target, 'mousemove', this);
      eventOperation(target, 'mousecancel', this);
      eventOperation(target, 'mouseup', this);
    }

    if (hasTouch && !this.options.disableTouch) {
      eventOperation(this.wrapper, 'touchstart', this);
      eventOperation(target, 'touchmove', this);
      eventOperation(target, 'touchcancel', this);
      eventOperation(target, 'touchend', this);
    }

    eventOperation(this.scroller, style.transitionEnd, this);
  };

  BScroll.prototype._initExtFeatures = function () {
    if (this.options.snap) {
      this._initSnap();
    }
    if (this.options.scrollbar) {
      this._initScrollbar();
    }
    if (this.options.pullUpLoad) {
      this._initPullUp();
    }
    if (this.options.pullDownRefresh) {
      this._initPullDown();
    }
    if (this.options.wheel) {
      this._initWheel();
    }
    if (this.options.mouseWheel) {
      this._initMouseWheel();
    }
    if (this.options.zoom) {
      this._initZoom();
    }
    if (this.options.infinity) {
      this._initInfinite();
    }
  };

  BScroll.prototype._watchTransition = function () {
    if (typeof Object.defineProperty !== 'function') {
      return;
    }
    var me = this;
    var isInTransition = false;
    var key = this.options.useTransition ? 'isInTransition' : 'isAnimating';
    Object.defineProperty(this, key, {
      get: function get() {
        return isInTransition;
      },
      set: function set(newVal) {
        isInTransition = newVal;
        // fix issue #359
        var el = me.scroller.children.length ? me.scroller.children : [me.scroller];
        var pointerEvents = isInTransition && !me.pulling ? 'none' : 'auto';
        for (var i = 0; i < el.length; i++) {
          el[i].style.pointerEvents = pointerEvents;
        }
      }
    });
  };

  BScroll.prototype._handleAutoBlur = function () {
    this.on('scrollStart', function () {
      var activeElement = document.activeElement;
      if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
        activeElement.blur();
      }
    });
  };

  BScroll.prototype._initDOMObserver = function () {
    var _this = this;

    if (typeof MutationObserver !== 'undefined') {
      var timer = void 0;
      var observer = new MutationObserver(function (mutations) {
        // don't do any refresh during the transition, or outside of the boundaries
        if (_this._shouldNotRefresh()) {
          return;
        }
        var immediateRefresh = false;
        var deferredRefresh = false;
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          if (mutation.type !== 'attributes') {
            immediateRefresh = true;
            break;
          } else {
            if (mutation.target !== _this.scroller) {
              deferredRefresh = true;
              break;
            }
          }
        }
        if (immediateRefresh) {
          _this.refresh();
        } else if (deferredRefresh) {
          // attributes changes too often
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (!_this._shouldNotRefresh()) {
              _this.refresh();
            }
          }, 60);
        }
      });
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };
      observer.observe(this.scroller, config);

      this.on('destroy', function () {
        observer.disconnect();
      });
    } else {
      this._checkDOMUpdate();
    }
  };

  BScroll.prototype._shouldNotRefresh = function () {
    var outsideBoundaries = this.x > this.minScrollX || this.x < this.maxScrollX || this.y > this.minScrollY || this.y < this.maxScrollY;

    return this.isInTransition || this.stopFromTransition || outsideBoundaries;
  };

  BScroll.prototype._checkDOMUpdate = function () {
    var scrollerRect = getRect(this.scroller);
    var oldWidth = scrollerRect.width;
    var oldHeight = scrollerRect.height;

    function check() {
      if (this.destroyed) {
        return;
      }
      scrollerRect = getRect(this.scroller);
      var newWidth = scrollerRect.width;
      var newHeight = scrollerRect.height;

      if (oldWidth !== newWidth || oldHeight !== newHeight) {
        this.refresh();
      }
      oldWidth = newWidth;
      oldHeight = newHeight;

      next.call(this);
    }

    function next() {
      var _this2 = this;

      setTimeout(function () {
        check.call(_this2);
      }, 1000);
    }

    next.call(this);
  };

  BScroll.prototype.handleEvent = function (e) {
    switch (e.type) {
      case 'touchstart':
      case 'mousedown':
        this._start(e);
        if (this.options.zoom && e.touches && e.touches.length > 1) {
          this._zoomStart(e);
        }
        break;
      case 'touchmove':
      case 'mousemove':
        if (this.options.zoom && e.touches && e.touches.length > 1) {
          this._zoom(e);
        } else {
          this._move(e);
        }
        break;
      case 'touchend':
      case 'mouseup':
      case 'touchcancel':
      case 'mousecancel':
        if (this.scaled) {
          this._zoomEnd(e);
        } else {
          this._end(e);
        }
        break;
      case 'orientationchange':
      case 'resize':
        this._resize();
        break;
      case 'transitionend':
      case 'webkitTransitionEnd':
      case 'oTransitionEnd':
      case 'MSTransitionEnd':
        this._transitionEnd(e);
        break;
      case 'click':
        if (this.enabled && !e._constructed) {
          if (!preventDefaultException(e.target, this.options.preventDefaultException)) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
        break;
      case 'wheel':
      case 'DOMMouseScroll':
      case 'mousewheel':
        this._onMouseWheel(e);
        break;
    }
  };

  BScroll.prototype.refresh = function () {
    var isWrapperStatic = window.getComputedStyle(this.wrapper, null).position === 'static';
    var wrapperRect = getRect(this.wrapper);
    this.wrapperWidth = wrapperRect.width;
    this.wrapperHeight = wrapperRect.height;

    var scrollerRect = getRect(this.scroller);
    this.scrollerWidth = Math.round(scrollerRect.width * this.scale);
    this.scrollerHeight = Math.round(scrollerRect.height * this.scale);

    this.relativeX = scrollerRect.left;
    this.relativeY = scrollerRect.top;

    if (isWrapperStatic) {
      this.relativeX -= wrapperRect.left;
      this.relativeY -= wrapperRect.top;
    }

    this.minScrollX = 0;
    this.minScrollY = 0;

    var wheel = this.options.wheel;
    if (wheel) {
      this.items = this.scroller.children;
      // check whether there are all disable items or not when refresh
      this._checkWheelAllDisabled();
      this.options.itemHeight = this.itemHeight = this.items.length ? this.scrollerHeight / this.items.length : 0;
      if (this.selectedIndex === undefined) {
        this.selectedIndex = wheel.selectedIndex || 0;
      }
      this.options.startY = -this.selectedIndex * this.itemHeight;

      this.maxScrollX = 0;
      this.maxScrollY = -this.itemHeight * (this.items.length - 1);
    } else {
      this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
      if (!this.options.infinity) {
        this.maxScrollY = this.wrapperHeight - this.scrollerHeight;
      }
      if (this.maxScrollX < 0) {
        this.maxScrollX -= this.relativeX;
        this.minScrollX = -this.relativeX;
      } else if (this.scale > 1) {
        this.maxScrollX = this.maxScrollX / 2 - this.relativeX;
        this.minScrollX = this.maxScrollX;
      }
      if (this.maxScrollY < 0) {
        this.maxScrollY -= this.relativeY;
        this.minScrollY = -this.relativeY;
      } else if (this.scale > 1) {
        this.maxScrollY = this.maxScrollY / 2 - this.relativeY;
        this.minScrollY = this.maxScrollY;
      }
    }

    this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < this.minScrollX;
    this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < this.minScrollY;

    if (!this.hasHorizontalScroll) {
      this.maxScrollX = this.minScrollX;
      this.scrollerWidth = this.wrapperWidth;
    }

    if (!this.hasVerticalScroll) {
      this.maxScrollY = this.minScrollY;
      this.scrollerHeight = this.wrapperHeight;
    }

    this.endTime = 0;
    this.directionX = 0;
    this.directionY = 0;
    this.wrapperOffset = offset(this.wrapper);

    this.trigger('refresh');

    !this.scaled && this.resetPosition();
  };

  BScroll.prototype.enable = function () {
    this.enabled = true;
  };

  BScroll.prototype.disable = function () {
    this.enabled = false;
  };
}

var ease = {
  // easeOutQuint
  swipe: {
    style: 'cubic-bezier(0.23, 1, 0.32, 1)',
    fn: function fn(t) {
      return 1 + --t * t * t * t * t;
    }
  },
  // easeOutQuard
  swipeBounce: {
    style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    fn: function fn(t) {
      return t * (2 - t);
    }
  },
  // easeOutQuart
  bounce: {
    style: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    fn: function fn(t) {
      return 1 - --t * t * t * t;
    }
  }
};

function momentum(current, start, time, lowerMargin, upperMargin, wrapperSize, options, scroll) {
  var distance = current - start;
  var speed = Math.abs(distance) / time;

  var deceleration = options.deceleration,
      itemHeight = options.itemHeight,
      swipeBounceTime = options.swipeBounceTime,
      wheel = options.wheel,
      swipeTime = options.swipeTime;

  var duration = swipeTime;
  var rate = wheel ? 4 : 15;

  var destination = current + speed / deceleration * (distance < 0 ? -1 : 1);

  if (wheel && itemHeight) {
    destination = scroll._findNearestValidWheel(destination).y;
  }

  if (destination < lowerMargin) {
    destination = wrapperSize ? Math.max(lowerMargin - wrapperSize / 4, lowerMargin - wrapperSize / rate * speed) : lowerMargin;
    duration = swipeBounceTime;
  } else if (destination > upperMargin) {
    destination = wrapperSize ? Math.min(upperMargin + wrapperSize / 4, upperMargin + wrapperSize / rate * speed) : upperMargin;
    duration = swipeBounceTime;
  }

  return {
    destination: Math.round(destination),
    duration: duration
  };
}

var DEFAULT_INTERVAL = 100 / 60;

function noop() {}

var requestAnimationFrame = function () {
  if (!inBrowser) {
    /* istanbul ignore if */
    return noop;
  }
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame ||
  // if all else fails, use setTimeout
  function (callback) {
    return window.setTimeout(callback, (callback.interval || DEFAULT_INTERVAL) / 2); // make interval as precise as possible.
  };
}();

var cancelAnimationFrame = function () {
  if (!inBrowser) {
    /* istanbul ignore if */
    return noop;
  }
  return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || function (id) {
    window.clearTimeout(id);
  };
}();

var DIRECTION_UP = 1;
var DIRECTION_DOWN = -1;
var DIRECTION_LEFT = 1;
var DIRECTION_RIGHT = -1;

var PROBE_DEBOUNCE = 1;

var PROBE_REALTIME = 3;

function warn(msg) {
  console.error('[BScroll warn]: ' + msg);
}

function assert(condition, msg) {
  if (!condition) {
    throw new Error('[BScroll] ' + msg);
  }
}

function coreMixin(BScroll) {
  BScroll.prototype._start = function (e) {
    var _eventType = eventType[e.type];
    if (_eventType !== TOUCH_EVENT) {
      if (e.button !== 0) {
        return;
      }
    }
    if (!this.enabled || this.destroyed || this.initiated && this.initiated !== _eventType) {
      return;
    }
    this.initiated = _eventType;

    if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
      e.preventDefault();
    }
    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    this.moved = false;
    this.distX = 0;
    this.distY = 0;
    this.directionX = 0;
    this.directionY = 0;
    this.movingDirectionX = 0;
    this.movingDirectionY = 0;
    this.directionLocked = 0;

    this._transitionTime();
    this.startTime = getNow();

    if (this.options.wheel) {
      this.target = e.target;
    }

    this.stop();

    var point = e.touches ? e.touches[0] : e;

    this.startX = this.x;
    this.startY = this.y;
    this.absStartX = this.x;
    this.absStartY = this.y;
    this.pointX = point.pageX;
    this.pointY = point.pageY;

    this.trigger('beforeScrollStart');
  };

  BScroll.prototype._move = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }

    if (this.options.preventDefault) {
      e.preventDefault();
    }
    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    var point = e.touches ? e.touches[0] : e;
    var deltaX = point.pageX - this.pointX;
    var deltaY = point.pageY - this.pointY;

    this.pointX = point.pageX;
    this.pointY = point.pageY;

    this.distX += deltaX;
    this.distY += deltaY;

    var absDistX = Math.abs(this.distX);
    var absDistY = Math.abs(this.distY);

    var timestamp = getNow();

    // We need to move at least momentumLimitDistance pixels for the scrolling to initiate
    if (timestamp - this.endTime > this.options.momentumLimitTime && !this.moved && absDistY < this.options.momentumLimitDistance && absDistX < this.options.momentumLimitDistance) {
      return;
    }

    // If you are scrolling in one direction lock the other
    if (!this.directionLocked && !this.options.freeScroll) {
      if (absDistX > absDistY + this.options.directionLockThreshold) {
        this.directionLocked = 'h'; // lock horizontally
      } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
        this.directionLocked = 'v'; // lock vertically
      } else {
        this.directionLocked = 'n'; // no lock
      }
    }

    if (this.directionLocked === 'h') {
      if (this.options.eventPassthrough === 'vertical') {
        e.preventDefault();
      } else if (this.options.eventPassthrough === 'horizontal') {
        this.initiated = false;
        return;
      }
      deltaY = 0;
    } else if (this.directionLocked === 'v') {
      if (this.options.eventPassthrough === 'horizontal') {
        e.preventDefault();
      } else if (this.options.eventPassthrough === 'vertical') {
        this.initiated = false;
        return;
      }
      deltaX = 0;
    }

    deltaX = this.hasHorizontalScroll ? deltaX : 0;
    deltaY = this.hasVerticalScroll ? deltaY : 0;
    this.movingDirectionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0;
    this.movingDirectionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0;

    var newX = this.x + deltaX;
    var newY = this.y + deltaY;

    var top = false;
    var bottom = false;
    var left = false;
    var right = false;
    // Slow down or stop if outside of the boundaries
    var bounce = this.options.bounce;
    if (bounce !== false) {
      top = bounce.top === undefined ? true : bounce.top;
      bottom = bounce.bottom === undefined ? true : bounce.bottom;
      left = bounce.left === undefined ? true : bounce.left;
      right = bounce.right === undefined ? true : bounce.right;
    }
    if (newX > this.minScrollX || newX < this.maxScrollX) {
      if (newX > this.minScrollX && left || newX < this.maxScrollX && right) {
        newX = this.x + deltaX / 3;
      } else {
        newX = newX > this.minScrollX ? this.minScrollX : this.maxScrollX;
      }
    }
    if (newY > this.minScrollY || newY < this.maxScrollY) {
      if (newY > this.minScrollY && top || newY < this.maxScrollY && bottom) {
        newY = this.y + deltaY / 3;
      } else {
        newY = newY > this.minScrollY ? this.minScrollY : this.maxScrollY;
      }
    }

    if (!this.moved) {
      this.moved = true;
      this.trigger('scrollStart');
    }

    this._translate(newX, newY);

    if (timestamp - this.startTime > this.options.momentumLimitTime) {
      this.startTime = timestamp;
      this.startX = this.x;
      this.startY = this.y;

      if (this.options.probeType === PROBE_DEBOUNCE) {
        this.trigger('scroll', {
          x: this.x,
          y: this.y
        });
      }
    }

    if (this.options.probeType > PROBE_DEBOUNCE) {
      this.trigger('scroll', {
        x: this.x,
        y: this.y
      });
    }

    var scrollLeft = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft;
    var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

    var pX = this.pointX - scrollLeft;
    var pY = this.pointY - scrollTop;

    if (pX > document.documentElement.clientWidth - this.options.momentumLimitDistance || pX < this.options.momentumLimitDistance || pY < this.options.momentumLimitDistance || pY > document.documentElement.clientHeight - this.options.momentumLimitDistance) {
      this._end(e);
    }
  };

  BScroll.prototype._end = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }
    this.initiated = false;

    if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
      e.preventDefault();
    }
    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    this.trigger('touchEnd', {
      x: this.x,
      y: this.y
    });

    this.isInTransition = false;

    // ensures that the last position is rounded
    var newX = Math.round(this.x);
    var newY = Math.round(this.y);

    var deltaX = newX - this.absStartX;
    var deltaY = newY - this.absStartY;
    this.directionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0;
    this.directionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0;

    // if configure pull down refresh, check it first
    if (this.options.pullDownRefresh && this._checkPullDown()) {
      return;
    }

    // check if it is a click operation
    if (this._checkClick(e)) {
      this.trigger('scrollCancel');
      return;
    }

    // reset if we are outside of the boundaries
    if (this.resetPosition(this.options.bounceTime, ease.bounce)) {
      return;
    }

    this._translate(newX, newY);

    this.endTime = getNow();
    var duration = this.endTime - this.startTime;
    var absDistX = Math.abs(newX - this.startX);
    var absDistY = Math.abs(newY - this.startY);

    // flick
    if (this._events.flick && duration < this.options.flickLimitTime && absDistX < this.options.flickLimitDistance && absDistY < this.options.flickLimitDistance) {
      this.trigger('flick');
      return;
    }

    var time = 0;
    // start momentum animation if needed
    if (this.options.momentum && duration < this.options.momentumLimitTime && (absDistY > this.options.momentumLimitDistance || absDistX > this.options.momentumLimitDistance)) {
      var top = false;
      var bottom = false;
      var left = false;
      var right = false;
      var bounce = this.options.bounce;
      if (bounce !== false) {
        top = bounce.top === undefined ? true : bounce.top;
        bottom = bounce.bottom === undefined ? true : bounce.bottom;
        left = bounce.left === undefined ? true : bounce.left;
        right = bounce.right === undefined ? true : bounce.right;
      }
      var wrapperWidth = this.directionX === DIRECTION_RIGHT && left || this.directionX === DIRECTION_LEFT && right ? this.wrapperWidth : 0;
      var wrapperHeight = this.directionY === DIRECTION_DOWN && top || this.directionY === DIRECTION_UP && bottom ? this.wrapperHeight : 0;
      var momentumX = this.hasHorizontalScroll ? momentum(this.x, this.startX, duration, this.maxScrollX, this.minScrollX, wrapperWidth, this.options, this) : { destination: newX, duration: 0 };
      var momentumY = this.hasVerticalScroll ? momentum(this.y, this.startY, duration, this.maxScrollY, this.minScrollY, wrapperHeight, this.options, this) : { destination: newY, duration: 0 };
      newX = momentumX.destination;
      newY = momentumY.destination;
      time = Math.max(momentumX.duration, momentumY.duration);
      this.isInTransition = true;
    } else {
      if (this.options.wheel) {
        newY = this._findNearestValidWheel(newY).y;
        time = this.options.wheel.adjustTime || 400;
      }
    }

    var easing = ease.swipe;
    if (this.options.snap) {
      var snap = this._nearestSnap(newX, newY);
      this.currentPage = snap;
      time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(newX - snap.x), 1000), Math.min(Math.abs(newY - snap.y), 1000)), 300);
      newX = snap.x;
      newY = snap.y;

      this.directionX = 0;
      this.directionY = 0;
      easing = this.options.snap.easing || ease.bounce;
    }

    if (newX !== this.x || newY !== this.y) {
      // change easing function when scroller goes out of the boundaries
      if (newX > this.minScrollX || newX < this.maxScrollX || newY > this.minScrollY || newY < this.maxScrollY) {
        easing = ease.swipeBounce;
      }
      this.scrollTo(newX, newY, time, easing);
      return;
    }

    if (this.options.wheel) {
      this.selectedIndex = this._findNearestValidWheel(this.y).index;
    }

    this.trigger('scrollEnd', {
      x: this.x,
      y: this.y
    });
  };

  BScroll.prototype._checkClick = function (e) {
    // when in the process of pulling down, it should not prevent click
    var preventClick = this.stopFromTransition && !this.pulling;
    this.stopFromTransition = false;

    // we scrolled less than 15 pixels
    if (!this.moved) {
      if (this.options.wheel) {
        if (this.target && this.target.className === this.options.wheel.wheelWrapperClass) {
          var index = this._findNearestValidWheel(this.y).index;
          var _offset = Math.round((this.pointY + offsetToBody(this.wrapper).top - this.wrapperHeight / 2) / this.itemHeight);
          this.target = this.items[index + _offset];
        }
        var top = offset(this.target).top;
        var left = offset(this.target).left;
        top -= this.wrapperOffset.top;
        top -= Math.round(this.target.offsetHeight / 2 - this.wrapper.offsetHeight / 2) || 0;
        left -= this.wrapperOffset.left;
        left -= Math.round(this.target.offsetWidth / 2 - this.wrapper.offsetWidth / 2) || 0;

        top = this._findNearestValidWheel(top).y;
        this.scrollTo(left, top, this.options.wheel.adjustTime || 400, ease.swipe);
        return true;
      } else {
        if (!preventClick) {
          var _dblclick = this.options.dblclick;
          var dblclickTrigged = false;
          if (_dblclick && this.lastClickTime) {
            var _dblclick$delay = _dblclick.delay,
                delay = _dblclick$delay === undefined ? 300 : _dblclick$delay;

            if (getNow() - this.lastClickTime < delay) {
              dblclickTrigged = true;
              dblclick(e);
            }
          }
          if (this.options.tap) {
            tap(e, this.options.tap);
          }

          if (this.options.click && !preventDefaultException(e.target, this.options.preventDefaultException)) {
            click(e);
          }
          this.lastClickTime = dblclickTrigged ? null : getNow();
          return true;
        }
        return false;
      }
    }
    return false;
  };

  BScroll.prototype._resize = function () {
    var _this = this;

    if (!this.enabled) {
      return;
    }
    // fix a scroll problem under Android condition
    if (isAndroid) {
      this.wrapper.scrollTop = 0;
    }
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(function () {
      _this.refresh();
    }, this.options.resizePolling);
  };

  BScroll.prototype._startProbe = function () {
    cancelAnimationFrame(this.probeTimer);
    this.probeTimer = requestAnimationFrame(probe);

    var me = this;

    function probe() {
      var pos = me.getComputedPosition();
      me.trigger('scroll', pos);
      if (!me.isInTransition) {
        me.trigger('scrollEnd', pos);
        return;
      }
      me.probeTimer = requestAnimationFrame(probe);
    }
  };

  BScroll.prototype._transitionTime = function () {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    this.scrollerStyle[style.transitionDuration] = time + 'ms';

    if (this.options.wheel) {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].style[style.transitionDuration] = time + 'ms';
      }
    }

    if (this.indicators) {
      for (var _i = 0; _i < this.indicators.length; _i++) {
        this.indicators[_i].transitionTime(time);
      }
    }
  };

  BScroll.prototype._transitionTimingFunction = function (easing) {
    this.scrollerStyle[style.transitionTimingFunction] = easing;

    if (this.options.wheel) {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].style[style.transitionTimingFunction] = easing;
      }
    }

    if (this.indicators) {
      for (var _i2 = 0; _i2 < this.indicators.length; _i2++) {
        this.indicators[_i2].transitionTimingFunction(easing);
      }
    }
  };

  BScroll.prototype._transitionEnd = function (e) {
    if (e.target !== this.scroller || !this.isInTransition) {
      return;
    }

    this._transitionTime();
    var needReset = !this.pulling || this.movingDirectionY === DIRECTION_UP;
    if (needReset && !this.resetPosition(this.options.bounceTime, ease.bounce)) {
      this.isInTransition = false;
      if (this.options.probeType !== PROBE_REALTIME) {
        this.trigger('scrollEnd', {
          x: this.x,
          y: this.y
        });
      }
    }
  };

  BScroll.prototype._translate = function (x, y, scale) {
    assert(!isUndef(x) && !isUndef(y), 'Translate x or y is null or undefined.');
    if (isUndef(scale)) {
      scale = this.scale;
    }
    if (this.options.useTransform) {
      this.scrollerStyle[style.transform] = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')' + this.translateZ;
    } else {
      x = Math.round(x);
      y = Math.round(y);
      this.scrollerStyle.left = x + 'px';
      this.scrollerStyle.top = y + 'px';
    }

    if (this.options.wheel) {
      var _options$wheel$rotate = this.options.wheel.rotate,
          rotate = _options$wheel$rotate === undefined ? 25 : _options$wheel$rotate;

      for (var i = 0; i < this.items.length; i++) {
        var deg = rotate * (y / this.itemHeight + i);
        this.items[i].style[style.transform] = 'rotateX(' + deg + 'deg)';
      }
    }

    this.x = x;
    this.y = y;
    this.setScale(scale);

    if (this.indicators) {
      for (var _i3 = 0; _i3 < this.indicators.length; _i3++) {
        this.indicators[_i3].updatePosition();
      }
    }
  };

  BScroll.prototype._animate = function (destX, destY, duration, easingFn) {
    var me = this;
    var startX = this.x;
    var startY = this.y;
    var startScale = this.lastScale;
    var destScale = this.scale;
    var startTime = getNow();
    var destTime = startTime + duration;

    function step() {
      var now = getNow();

      if (now >= destTime) {
        me.isAnimating = false;
        me._translate(destX, destY, destScale);

        me.trigger('scroll', {
          x: me.x,
          y: me.y
        });

        if (!me.pulling && !me.resetPosition(me.options.bounceTime)) {
          me.trigger('scrollEnd', {
            x: me.x,
            y: me.y
          });
        }
        return;
      }
      now = (now - startTime) / duration;
      var easing = easingFn(now);
      var newX = (destX - startX) * easing + startX;
      var newY = (destY - startY) * easing + startY;
      var newScale = (destScale - startScale) * easing + startScale;

      me._translate(newX, newY, newScale);

      if (me.isAnimating) {
        me.animateTimer = requestAnimationFrame(step);
      }

      if (me.options.probeType === PROBE_REALTIME) {
        me.trigger('scroll', {
          x: me.x,
          y: me.y
        });
      }
    }

    this.isAnimating = true;
    cancelAnimationFrame(this.animateTimer);
    step();
  };

  BScroll.prototype.scrollBy = function (x, y) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ease.bounce;

    x = this.x + x;
    y = this.y + y;

    this.scrollTo(x, y, time, easing);
  };

  BScroll.prototype.scrollTo = function (x, y) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ease.bounce;
    var isSilent = arguments[4];

    if (this.options.wheel) {
      y = this._findNearestValidWheel(y).y;
    }
    if (x === this.x && y === this.y) {
      return;
    }
    this.isInTransition = this.options.useTransition && time > 0 && (this.x !== x || this.y !== y);

    if (!time || this.options.useTransition) {
      this._transitionTimingFunction(easing.style);
      this._transitionTime(time);
      this._translate(x, y);

      if (time && this.options.probeType === PROBE_REALTIME) {
        this._startProbe();
      }
      if (!time && !isSilent) {
        // don't trigger resetPosition when zoom feature is open, fix #748
        if (this.options.zoom) return;
        this.trigger('scroll', {
          x: x,
          y: y
        });
        // force reflow to put everything in position
        this._reflow = document.body.offsetHeight;
        if (!this.resetPosition(this.options.bounceTime, ease.bounce)) {
          this.trigger('scrollEnd', {
            x: x,
            y: y
          });
        }
      }

      if (this.options.wheel) {
        this.selectedIndex = this._findNearestValidWheel(y).index;
      }
    } else {
      this._animate(x, y, time, easing.fn);
    }
  };

  BScroll.prototype.scrollToElement = function (el, time, offsetX, offsetY, easing) {
    if (!el) {
      return;
    }
    el = el.nodeType ? el : this.scroller.querySelector(el);

    if (this.options.wheel && !el.classList.contains(this.options.wheel.wheelItemClass)) {
      return;
    }

    var pos = offset(el);
    pos.left -= this.wrapperOffset.left;
    pos.top -= this.wrapperOffset.top;

    // if offsetX/Y are true we center the element to the screen
    if (offsetX === true) {
      offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
    }
    if (offsetY === true) {
      offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
    }

    pos.left -= offsetX || 0;
    pos.top -= offsetY || 0;
    pos.left = pos.left > this.minScrollX ? this.minScrollX : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
    pos.top = pos.top > this.minScrollY ? this.minScrollY : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

    if (this.options.wheel) {
      pos.top = this._findNearestValidWheel(pos.top).y;
    }

    this.scrollTo(pos.left, pos.top, time, easing);
  };

  BScroll.prototype.resetPosition = function () {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var easeing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ease.bounce;

    var x = this.x;
    var roundX = Math.round(x);
    if (!this.hasHorizontalScroll || roundX > this.minScrollX) {
      x = this.minScrollX;
    } else if (roundX < this.maxScrollX) {
      x = this.maxScrollX;
    }

    var y = this.y;
    var roundY = Math.round(y);
    if (!this.hasVerticalScroll || roundY > this.minScrollY) {
      y = this.minScrollY;
    } else if (roundY < this.maxScrollY) {
      y = this.maxScrollY;
    }

    if (x === this.x && y === this.y) {
      return false;
    }

    this.scrollTo(x, y, time, easeing);

    return true;
  };

  BScroll.prototype.getComputedPosition = function () {
    var matrix = window.getComputedStyle(this.scroller, null);
    var x = void 0;
    var y = void 0;

    if (this.options.useTransform) {
      matrix = matrix[style.transform].split(')')[0].split(', ');
      x = +(matrix[12] || matrix[4]);
      y = +(matrix[13] || matrix[5]);
    } else {
      x = +matrix.left.replace(/[^-\d.]/g, '');
      y = +matrix.top.replace(/[^-\d.]/g, '');
    }

    return {
      x: x,
      y: y
    };
  };

  BScroll.prototype.stop = function () {
    if (this.options.useTransition && this.isInTransition) {
      this.isInTransition = false;
      cancelAnimationFrame(this.probeTimer);
      var pos = this.getComputedPosition();
      this._translate(pos.x, pos.y);
      if (this.options.wheel) {
        this.target = this.items[this._findNearestValidWheel(pos.y).index];
      } else {
        this.trigger('scrollEnd', {
          x: this.x,
          y: this.y
        });
      }
      this.stopFromTransition = true;
    } else if (!this.options.useTransition && this.isAnimating) {
      this.isAnimating = false;
      cancelAnimationFrame(this.animateTimer);
      this.trigger('scrollEnd', {
        x: this.x,
        y: this.y
      });
      this.stopFromTransition = true;
    }
  };

  BScroll.prototype.destroy = function () {
    this.destroyed = true;
    this.trigger('destroy');
    if (this.options.useTransition) {
      cancelAnimationFrame(this.probeTimer);
    } else {
      cancelAnimationFrame(this.animateTimer);
    }
    this._removeDOMEvents();
    // remove custom events
    this._events = {};
  };
}

function snapMixin(BScroll) {
  BScroll.prototype._initSnap = function () {
    var _this = this;

    this.currentPage = {};
    var snap = this.options.snap;

    if (snap.loop) {
      var children = this.scroller.children;
      if (children.length > 1) {
        prepend(children[children.length - 1].cloneNode(true), this.scroller);
        this.scroller.appendChild(children[1].cloneNode(true));
      } else {
        // Loop does not make any sense if there is only one child.
        snap.loop = false;
      }
    }

    var el = snap.el;
    if (typeof el === 'string') {
      el = this.scroller.querySelectorAll(el);
    }

    this.on('refresh', function () {
      _this.pages = [];

      if (!_this.wrapperWidth || !_this.wrapperHeight || !_this.scrollerWidth || !_this.scrollerHeight) {
        return;
      }

      var stepX = snap.stepX || _this.wrapperWidth;
      var stepY = snap.stepY || _this.wrapperHeight;

      var x = 0;
      var y = void 0;
      var cx = void 0;
      var cy = void 0;
      var i = 0;
      var l = void 0;
      var m = 0;
      var n = void 0;
      var rect = void 0;
      if (!el) {
        cx = Math.round(stepX / 2);
        cy = Math.round(stepY / 2);

        while (x > -_this.scrollerWidth) {
          _this.pages[i] = [];
          l = 0;
          y = 0;

          while (y > -_this.scrollerHeight) {
            _this.pages[i][l] = {
              x: Math.max(x, _this.maxScrollX),
              y: Math.max(y, _this.maxScrollY),
              width: stepX,
              height: stepY,
              cx: x - cx,
              cy: y - cy
            };

            y -= stepY;
            l++;
          }

          x -= stepX;
          i++;
        }
      } else {
        l = el.length;
        n = -1;

        for (; i < l; i++) {
          rect = getRect(el[i]);
          if (i === 0 || rect.left <= getRect(el[i - 1]).left) {
            m = 0;
            n++;
          }

          if (!_this.pages[m]) {
            _this.pages[m] = [];
          }

          x = Math.max(-rect.left, _this.maxScrollX);
          y = Math.max(-rect.top, _this.maxScrollY);
          cx = x - Math.round(rect.width / 2);
          cy = y - Math.round(rect.height / 2);

          _this.pages[m][n] = {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height,
            cx: cx,
            cy: cy
          };

          if (x > _this.maxScrollX) {
            m++;
          }
        }
      }

      _this._checkSnapLoop();

      var initPageX = snap._loopX ? 1 : 0;
      var initPageY = snap._loopY ? 1 : 0;
      _this._goToPage(_this.currentPage.pageX || initPageX, _this.currentPage.pageY || initPageY, 0, undefined, true);

      // Update snap threshold if needed.
      var snapThreshold = snap.threshold;
      if (snapThreshold % 1 === 0) {
        _this.snapThresholdX = snapThreshold;
        _this.snapThresholdY = snapThreshold;
      } else {
        _this.snapThresholdX = Math.round(_this.pages[_this.currentPage.pageX][_this.currentPage.pageY].width * snapThreshold);
        _this.snapThresholdY = Math.round(_this.pages[_this.currentPage.pageX][_this.currentPage.pageY].height * snapThreshold);
      }
    });

    this.on('scrollEnd', function () {
      if (snap.loop) {
        if (snap._loopX) {
          if (_this.currentPage.pageX === 0) {
            _this._goToPage(_this.pages.length - 2, _this.currentPage.pageY, 0, undefined, true);
          }
          if (_this.currentPage.pageX === _this.pages.length - 1) {
            _this._goToPage(1, _this.currentPage.pageY, 0, undefined, true);
          }
        } else {
          if (_this.currentPage.pageY === 0) {
            _this._goToPage(_this.currentPage.pageX, _this.pages[0].length - 2, 0, undefined, true);
          }
          if (_this.currentPage.pageY === _this.pages[0].length - 1) {
            _this._goToPage(_this.currentPage.pageX, 1, 0, undefined, true);
          }
        }
      }
    });

    if (snap.listenFlick !== false) {
      this.on('flick', function () {
        var time = snap.speed || Math.max(Math.max(Math.min(Math.abs(_this.x - _this.startX), 1000), Math.min(Math.abs(_this.y - _this.startY), 1000)), 300);

        _this._goToPage(_this.currentPage.pageX + _this.directionX, _this.currentPage.pageY + _this.directionY, time);
      });
    }

    this.on('destroy', function () {
      if (snap.loop) {
        var _children = _this.scroller.children;
        if (_children.length > 2) {
          removeChild(_this.scroller, _children[_children.length - 1]);
          removeChild(_this.scroller, _children[0]);
        }
      }
    });
  };

  BScroll.prototype._checkSnapLoop = function () {
    var snap = this.options.snap;

    if (!snap.loop || !this.pages || !this.pages.length) {
      return;
    }

    if (this.pages.length > 1) {
      snap._loopX = true;
    }
    if (this.pages[0] && this.pages[0].length > 1) {
      snap._loopY = true;
    }
    if (snap._loopX && snap._loopY) {
      warn('Loop does not support two direction at the same time.');
    }
  };

  BScroll.prototype._nearestSnap = function (x, y) {
    if (!this.pages.length) {
      return { x: 0, y: 0, pageX: 0, pageY: 0 };
    }

    var i = 0;
    // Check if we exceeded the snap threshold
    if (Math.abs(x - this.absStartX) <= this.snapThresholdX && Math.abs(y - this.absStartY) <= this.snapThresholdY) {
      return this.currentPage;
    }

    if (x > this.minScrollX) {
      x = this.minScrollX;
    } else if (x < this.maxScrollX) {
      x = this.maxScrollX;
    }

    if (y > this.minScrollY) {
      y = this.minScrollY;
    } else if (y < this.maxScrollY) {
      y = this.maxScrollY;
    }

    var l = this.pages.length;
    for (; i < l; i++) {
      if (x >= this.pages[i][0].cx) {
        x = this.pages[i][0].x;
        break;
      }
    }

    l = this.pages[i].length;

    var m = 0;
    for (; m < l; m++) {
      if (y >= this.pages[0][m].cy) {
        y = this.pages[0][m].y;
        break;
      }
    }

    if (i === this.currentPage.pageX) {
      i += this.directionX;

      if (i < 0) {
        i = 0;
      } else if (i >= this.pages.length) {
        i = this.pages.length - 1;
      }

      x = this.pages[i][0].x;
    }

    if (m === this.currentPage.pageY) {
      m += this.directionY;

      if (m < 0) {
        m = 0;
      } else if (m >= this.pages[0].length) {
        m = this.pages[0].length - 1;
      }

      y = this.pages[0][m].y;
    }

    return {
      x: x,
      y: y,
      pageX: i,
      pageY: m
    };
  };

  BScroll.prototype._goToPage = function (x) {
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var time = arguments[2];
    var easing = arguments[3];
    var isSilent = arguments[4];

    var snap = this.options.snap;

    if (!snap || !this.pages || !this.pages.length) {
      return;
    }

    easing = easing || snap.easing || ease.bounce;

    if (x >= this.pages.length) {
      x = this.pages.length - 1;
    } else if (x < 0) {
      x = 0;
    }

    if (!this.pages[x]) {
      return;
    }

    if (y >= this.pages[x].length) {
      y = this.pages[x].length - 1;
    } else if (y < 0) {
      y = 0;
    }

    var posX = this.pages[x][y].x;
    var posY = this.pages[x][y].y;

    time = time === undefined ? snap.speed || Math.max(Math.max(Math.min(Math.abs(posX - this.x), 1000), Math.min(Math.abs(posY - this.y), 1000)), 300) : time;

    this.currentPage = {
      x: posX,
      y: posY,
      pageX: x,
      pageY: y
    };
    this.scrollTo(posX, posY, time, easing, isSilent);
  };

  BScroll.prototype.goToPage = function (x, y, time, easing) {
    var snap = this.options.snap;
    if (!snap || !this.pages || !this.pages.length) {
      return;
    }

    if (snap.loop) {
      var len = void 0;
      if (snap._loopX) {
        len = this.pages.length - 2;
        if (x >= len) {
          x = len - 1;
        } else if (x < 0) {
          x = 0;
        }
        x += 1;
      } else {
        len = this.pages[0].length - 2;
        if (y >= len) {
          y = len - 1;
        } else if (y < 0) {
          y = 0;
        }
        y += 1;
      }
    }
    this._goToPage(x, y, time, easing);
  };

  BScroll.prototype.next = function (time, easing) {
    var snap = this.options.snap;
    if (!snap) {
      return;
    }

    var x = this.currentPage.pageX;
    var y = this.currentPage.pageY;

    x++;
    if (x >= this.pages.length && this.hasVerticalScroll) {
      x = 0;
      y++;
    }

    this._goToPage(x, y, time, easing);
  };

  BScroll.prototype.prev = function (time, easing) {
    var snap = this.options.snap;
    if (!snap) {
      return;
    }

    var x = this.currentPage.pageX;
    var y = this.currentPage.pageY;

    x--;
    if (x < 0 && this.hasVerticalScroll) {
      x = 0;
      y--;
    }

    this._goToPage(x, y, time, easing);
  };

  BScroll.prototype.getCurrentPage = function () {
    var snap = this.options.snap;
    if (!snap) {
      return null;
    }

    if (snap.loop) {
      var currentPage = void 0;
      if (snap._loopX) {
        currentPage = extend({}, this.currentPage, {
          pageX: this.currentPage.pageX - 1
        });
      } else {
        currentPage = extend({}, this.currentPage, {
          pageY: this.currentPage.pageY - 1
        });
      }
      return currentPage;
    }
    return this.currentPage;
  };
}

function wheelMixin(BScroll) {
  BScroll.prototype.wheelTo = function () {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (this.options.wheel) {
      var y = -index * this.itemHeight;
      this.scrollTo(0, y);
    }
  };

  BScroll.prototype.getSelectedIndex = function () {
    return this.options.wheel && this.selectedIndex;
  };

  BScroll.prototype._initWheel = function () {
    var wheel = this.options.wheel;
    if (!wheel.wheelWrapperClass) {
      wheel.wheelWrapperClass = 'wheel-scroll';
    }
    if (!wheel.wheelItemClass) {
      wheel.wheelItemClass = 'wheel-item';
    }
    if (!wheel.wheelDisabledItemClass) {
      wheel.wheelDisabledItemClass = 'wheel-disabled-item';
    }
    if (wheel.selectedIndex === undefined) {
      wheel.selectedIndex = 0;
    }
  };

  BScroll.prototype._findNearestValidWheel = function (y) {
    y = y > 0 ? 0 : y < this.maxScrollY ? this.maxScrollY : y;
    var wheel = this.options.wheel;
    var currentIndex = Math.abs(Math.round(-y / this.itemHeight));
    var cacheIndex = currentIndex;
    var items = this.items;
    // Impersonation web native select
    // first, check whether there is a enable item whose index is smaller than currentIndex
    // then, check whether there is a enable item whose index is bigger than currentIndex
    // otherwise, there are all disabled items, just keep currentIndex unchange
    while (currentIndex >= 0) {
      if (items[currentIndex].className.indexOf(wheel.wheelDisabledItemClass) === -1) {
        break;
      }
      currentIndex--;
    }

    if (currentIndex < 0) {
      currentIndex = cacheIndex;
      while (currentIndex <= items.length - 1) {
        if (items[currentIndex].className.indexOf(wheel.wheelDisabledItemClass) === -1) {
          break;
        }
        currentIndex++;
      }
    }

    // keep it unchange when all the items are disabled
    if (currentIndex === items.length) {
      currentIndex = cacheIndex;
    }
    // when all the items are disabled, this.selectedIndex should always be -1
    return {
      index: this.wheelItemsAllDisabled ? -1 : currentIndex,
      y: -currentIndex * this.itemHeight
    };
  };

  BScroll.prototype._checkWheelAllDisabled = function () {
    var wheel = this.options.wheel;
    var items = this.items;
    this.wheelItemsAllDisabled = true;
    for (var i = 0; i < items.length; i++) {
      if (items[i].className.indexOf(wheel.wheelDisabledItemClass) === -1) {
        this.wheelItemsAllDisabled = false;
        break;
      }
    }
  };
}

var INDICATOR_MIN_LEN = 8;

function scrollbarMixin(BScroll) {
  BScroll.prototype._initScrollbar = function () {
    var _this = this;

    var _options$scrollbar = this.options.scrollbar,
        _options$scrollbar$fa = _options$scrollbar.fade,
        fade = _options$scrollbar$fa === undefined ? true : _options$scrollbar$fa,
        _options$scrollbar$in = _options$scrollbar.interactive,
        interactive = _options$scrollbar$in === undefined ? false : _options$scrollbar$in;

    this.indicators = [];
    var indicator = void 0;

    if (this.options.scrollX) {
      indicator = {
        el: createScrollbar('horizontal'),
        direction: 'horizontal',
        fade: fade,
        interactive: interactive
      };
      this._insertScrollBar(indicator.el);

      this.indicators.push(new Indicator(this, indicator));
    }

    if (this.options.scrollY) {
      indicator = {
        el: createScrollbar('vertical'),
        direction: 'vertical',
        fade: fade,
        interactive: interactive
      };
      this._insertScrollBar(indicator.el);
      this.indicators.push(new Indicator(this, indicator));
    }

    this.on('refresh', function () {
      for (var i = 0; i < _this.indicators.length; i++) {
        _this.indicators[i].refresh();
      }
    });

    if (fade) {
      this.on('scrollEnd', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade();
        }
      });

      this.on('scrollCancel', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade();
        }
      });

      this.on('scrollStart', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade(true);
        }
      });

      this.on('beforeScrollStart', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade(true, true);
        }
      });
    }

    this.on('destroy', function () {
      _this._removeScrollBars();
    });
  };

  BScroll.prototype._insertScrollBar = function (scrollbar) {
    this.wrapper.appendChild(scrollbar);
  };

  BScroll.prototype._removeScrollBars = function () {
    for (var i = 0; i < this.indicators.length; i++) {
      this.indicators[i].destroy();
    }
  };
}

function createScrollbar(direction) {
  var scrollbar = document.createElement('div');
  var indicator = document.createElement('div');

  scrollbar.style.cssText = 'position:absolute;z-index:9999;pointerEvents:none';
  indicator.style.cssText = 'box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px;';

  indicator.className = 'bscroll-indicator';

  if (direction === 'horizontal') {
    scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
    indicator.style.height = '100%';
    scrollbar.className = 'bscroll-horizontal-scrollbar';
  } else {
    scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
    indicator.style.width = '100%';
    scrollbar.className = 'bscroll-vertical-scrollbar';
  }

  scrollbar.style.cssText += ';overflow:hidden';
  scrollbar.appendChild(indicator);

  return scrollbar;
}

function Indicator(scroller, options) {
  this.wrapper = options.el;
  this.wrapperStyle = this.wrapper.style;
  this.indicator = this.wrapper.children[0];
  this.indicatorStyle = this.indicator.style;
  this.scroller = scroller;
  this.direction = options.direction;
  if (options.fade) {
    this.visible = 0;
    this.wrapperStyle.opacity = '0';
  } else {
    this.visible = 1;
  }

  this.sizeRatioX = 1;
  this.sizeRatioY = 1;
  this.maxPosX = 0;
  this.maxPosY = 0;
  this.x = 0;
  this.y = 0;

  if (options.interactive) {
    this._addDOMEvents();
  }
}

Indicator.prototype.handleEvent = function (e) {
  switch (e.type) {
    case 'touchstart':
    case 'mousedown':
      this._start(e);
      break;
    case 'touchmove':
    case 'mousemove':
      this._move(e);
      break;
    case 'touchend':
    case 'mouseup':
    case 'touchcancel':
    case 'mousecancel':
      this._end(e);
      break;
  }
};

Indicator.prototype.refresh = function () {
  if (this._shouldShow()) {
    this.transitionTime();
    this._calculate();
    this.updatePosition();
  }
};

Indicator.prototype.fade = function (visible, hold) {
  var _this2 = this;

  if (hold && !this.visible) {
    return;
  }

  var time = visible ? 250 : 500;

  visible = visible ? '1' : '0';

  this.wrapperStyle[style.transitionDuration] = time + 'ms';

  clearTimeout(this.fadeTimeout);
  this.fadeTimeout = setTimeout(function () {
    _this2.wrapperStyle.opacity = visible;
    _this2.visible = +visible;
  }, 0);
};

Indicator.prototype.updatePosition = function () {
  if (this.direction === 'vertical') {
    var y = Math.round(this.sizeRatioY * this.scroller.y);

    if (y < 0) {
      this.transitionTime(500);
      var height = Math.max(this.indicatorHeight + y * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.height = height + 'px';
      y = 0;
    } else if (y > this.maxPosY) {
      this.transitionTime(500);
      var _height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.height = _height + 'px';
      y = this.maxPosY + this.indicatorHeight - _height;
    } else {
      this.indicatorStyle.height = this.indicatorHeight + 'px';
    }
    this.y = y;

    if (this.scroller.options.useTransform) {
      this.indicatorStyle[style.transform] = 'translateY(' + y + 'px)' + this.scroller.translateZ;
    } else {
      this.indicatorStyle.top = y + 'px';
    }
  } else {
    var x = Math.round(this.sizeRatioX * this.scroller.x);

    if (x < 0) {
      this.transitionTime(500);
      var width = Math.max(this.indicatorWidth + x * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.width = width + 'px';
      x = 0;
    } else if (x > this.maxPosX) {
      this.transitionTime(500);
      var _width = Math.max(this.indicatorWidth - (x - this.maxPosX) * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.width = _width + 'px';
      x = this.maxPosX + this.indicatorWidth - _width;
    } else {
      this.indicatorStyle.width = this.indicatorWidth + 'px';
    }

    this.x = x;

    if (this.scroller.options.useTransform) {
      this.indicatorStyle[style.transform] = 'translateX(' + x + 'px)' + this.scroller.translateZ;
    } else {
      this.indicatorStyle.left = x + 'px';
    }
  }
};

Indicator.prototype.transitionTime = function () {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  this.indicatorStyle[style.transitionDuration] = time + 'ms';
};

Indicator.prototype.transitionTimingFunction = function (easing) {
  this.indicatorStyle[style.transitionTimingFunction] = easing;
};

Indicator.prototype.destroy = function () {
  this._removeDOMEvents();
  this.wrapper.parentNode.removeChild(this.wrapper);
};

Indicator.prototype._start = function (e) {
  var point = e.touches ? e.touches[0] : e;

  e.preventDefault();
  e.stopPropagation();

  this.transitionTime();

  this.initiated = true;
  this.moved = false;
  this.lastPointX = point.pageX;
  this.lastPointY = point.pageY;

  this.startTime = getNow();

  this._handleMoveEvents(addEvent);
  this.scroller.trigger('beforeScrollStart');
};

Indicator.prototype._move = function (e) {
  var point = e.touches ? e.touches[0] : e;

  e.preventDefault();
  e.stopPropagation();

  if (!this.moved) {
    this.scroller.trigger('scrollStart');
  }

  this.moved = true;

  var deltaX = point.pageX - this.lastPointX;
  this.lastPointX = point.pageX;

  var deltaY = point.pageY - this.lastPointY;
  this.lastPointY = point.pageY;

  var newX = this.x + deltaX;
  var newY = this.y + deltaY;

  this._pos(newX, newY);
};

Indicator.prototype._end = function (e) {
  if (!this.initiated) {
    return;
  }
  this.initiated = false;

  e.preventDefault();
  e.stopPropagation();

  this._handleMoveEvents(removeEvent);

  var snapOption = this.scroller.options.snap;
  if (snapOption) {
    var speed = snapOption.speed,
        _snapOption$easing = snapOption.easing,
        easing = _snapOption$easing === undefined ? ease.bounce : _snapOption$easing;

    var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

    var time = speed || Math.max(Math.max(Math.min(Math.abs(this.scroller.x - snap.x), 1000), Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);

    if (this.scroller.x !== snap.x || this.scroller.y !== snap.y) {
      this.scroller.directionX = 0;
      this.scroller.directionY = 0;
      this.scroller.currentPage = snap;
      this.scroller.scrollTo(snap.x, snap.y, time, easing);
    }
  }

  if (this.moved) {
    this.scroller.trigger('scrollEnd', {
      x: this.scroller.x,
      y: this.scroller.y
    });
  }
};

Indicator.prototype._pos = function (x, y) {
  if (x < 0) {
    x = 0;
  } else if (x > this.maxPosX) {
    x = this.maxPosX;
  }

  if (y < 0) {
    y = 0;
  } else if (y > this.maxPosY) {
    y = this.maxPosY;
  }

  x = Math.round(x / this.sizeRatioX);
  y = Math.round(y / this.sizeRatioY);

  this.scroller.scrollTo(x, y);
  this.scroller.trigger('scroll', {
    x: this.scroller.x,
    y: this.scroller.y
  });
};

Indicator.prototype._shouldShow = function () {
  if (this.direction === 'vertical' && this.scroller.hasVerticalScroll || this.direction === 'horizontal' && this.scroller.hasHorizontalScroll) {
    this.wrapper.style.display = '';
    return true;
  }
  this.wrapper.style.display = 'none';
  return false;
};

Indicator.prototype._calculate = function () {
  if (this.direction === 'vertical') {
    var wrapperHeight = this.wrapper.clientHeight;
    this.indicatorHeight = Math.max(Math.round(wrapperHeight * wrapperHeight / (this.scroller.scrollerHeight || wrapperHeight || 1)), INDICATOR_MIN_LEN);
    this.indicatorStyle.height = this.indicatorHeight + 'px';

    this.maxPosY = wrapperHeight - this.indicatorHeight;

    this.sizeRatioY = this.maxPosY / this.scroller.maxScrollY;
  } else {
    var wrapperWidth = this.wrapper.clientWidth;
    this.indicatorWidth = Math.max(Math.round(wrapperWidth * wrapperWidth / (this.scroller.scrollerWidth || wrapperWidth || 1)), INDICATOR_MIN_LEN);
    this.indicatorStyle.width = this.indicatorWidth + 'px';

    this.maxPosX = wrapperWidth - this.indicatorWidth;

    this.sizeRatioX = this.maxPosX / this.scroller.maxScrollX;
  }
};

Indicator.prototype._addDOMEvents = function () {
  var eventOperation = addEvent;
  this._handleDOMEvents(eventOperation);
};

Indicator.prototype._removeDOMEvents = function () {
  var eventOperation = removeEvent;
  this._handleDOMEvents(eventOperation);
  this._handleMoveEvents(eventOperation);
};

Indicator.prototype._handleMoveEvents = function (eventOperation) {
  if (!this.scroller.options.disableTouch) {
    eventOperation(window, 'touchmove', this);
  }
  if (!this.scroller.options.disableMouse) {
    eventOperation(window, 'mousemove', this);
  }
};

Indicator.prototype._handleDOMEvents = function (eventOperation) {
  if (!this.scroller.options.disableTouch) {
    eventOperation(this.indicator, 'touchstart', this);
    eventOperation(window, 'touchend', this);
  }
  if (!this.scroller.options.disableMouse) {
    eventOperation(this.indicator, 'mousedown', this);
    eventOperation(window, 'mouseup', this);
  }
};

function pullDownMixin(BScroll) {
  BScroll.prototype._initPullDown = function () {
    // must watch scroll in real time
    this.options.probeType = PROBE_REALTIME;
  };

  BScroll.prototype._checkPullDown = function () {
    var _options$pullDownRefr = this.options.pullDownRefresh,
        _options$pullDownRefr2 = _options$pullDownRefr.threshold,
        threshold = _options$pullDownRefr2 === undefined ? 90 : _options$pullDownRefr2,
        _options$pullDownRefr3 = _options$pullDownRefr.stop,
        stop = _options$pullDownRefr3 === undefined ? 40 : _options$pullDownRefr3;

    // check if a real pull down action

    if (this.directionY !== DIRECTION_DOWN || this.y < threshold) {
      return false;
    }

    if (!this.pulling) {
      this.pulling = true;
      this.trigger('pullingDown');
    }
    this.scrollTo(this.x, stop, this.options.bounceTime, ease.bounce);

    return this.pulling;
  };

  BScroll.prototype.finishPullDown = function () {
    this.pulling = false;
    this.resetPosition(this.options.bounceTime, ease.bounce);
  };

  BScroll.prototype.openPullDown = function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.options.pullDownRefresh = config;
    this._initPullDown();
  };

  BScroll.prototype.closePullDown = function () {
    this.options.pullDownRefresh = false;
  };

  BScroll.prototype.autoPullDownRefresh = function () {
    var _options$pullDownRefr4 = this.options.pullDownRefresh,
        _options$pullDownRefr5 = _options$pullDownRefr4.threshold,
        threshold = _options$pullDownRefr5 === undefined ? 90 : _options$pullDownRefr5,
        _options$pullDownRefr6 = _options$pullDownRefr4.stop,
        stop = _options$pullDownRefr6 === undefined ? 40 : _options$pullDownRefr6;


    if (this.pulling) {
      return;
    }
    this.pulling = true;

    this.scrollTo(this.x, threshold);
    this.trigger('pullingDown');
    this.scrollTo(this.x, stop, this.options.bounceTime, ease.bounce);
  };
}

function pullUpMixin(BScroll) {
  BScroll.prototype._initPullUp = function () {
    // must watch scroll in real time
    this.options.probeType = PROBE_REALTIME;

    this.pullupWatching = false;
    this._watchPullUp();
  };

  BScroll.prototype._watchPullUp = function () {
    if (this.pullupWatching) {
      return;
    }
    this.pullupWatching = true;
    this.on('scroll', this._checkToEnd);
  };

  BScroll.prototype._checkToEnd = function (pos) {
    var _this = this;

    var _options$pullUpLoad$t = this.options.pullUpLoad.threshold,
        threshold = _options$pullUpLoad$t === undefined ? 0 : _options$pullUpLoad$t;

    if (this.movingDirectionY === DIRECTION_UP && pos.y <= this.maxScrollY + threshold) {
      // reset pullupWatching status after scroll end.
      this.once('scrollEnd', function () {
        _this.pullupWatching = false;
      });
      this.trigger('pullingUp');
      this.off('scroll', this._checkToEnd);
    }
  };

  BScroll.prototype.finishPullUp = function () {
    var _this2 = this;

    if (this.pullupWatching) {
      this.once('scrollEnd', function () {
        _this2._watchPullUp();
      });
    } else {
      this._watchPullUp();
    }
  };

  BScroll.prototype.openPullUp = function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.options.pullUpLoad = config;
    this._initPullUp();
  };

  BScroll.prototype.closePullUp = function () {
    this.options.pullUpLoad = false;
    if (!this.pullupWatching) {
      return;
    }
    this.pullupWatching = false;
    this.off('scroll', this._checkToEnd);
  };
}

function mouseWheelMixin(BScroll) {
  BScroll.prototype._initMouseWheel = function () {
    var _this = this;

    this._handleMouseWheelEvent(addEvent);

    this.on('destroy', function () {
      clearTimeout(_this.mouseWheelTimer);
      clearTimeout(_this.mouseWheelEndTimer);
      _this._handleMouseWheelEvent(removeEvent);
    });

    this.firstWheelOpreation = true;
  };

  BScroll.prototype._handleMouseWheelEvent = function (eventOperation) {
    eventOperation(this.wrapper, 'wheel', this);
    eventOperation(this.wrapper, 'mousewheel', this);
    eventOperation(this.wrapper, 'DOMMouseScroll', this);
  };

  BScroll.prototype._onMouseWheel = function (e) {
    var _this2 = this;

    if (!this.enabled) {
      return;
    }
    e.preventDefault();

    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    if (this.firstWheelOpreation) {
      this.trigger('scrollStart');
    }
    this.firstWheelOpreation = false;

    var _options$mouseWheel = this.options.mouseWheel,
        _options$mouseWheel$s = _options$mouseWheel.speed,
        speed = _options$mouseWheel$s === undefined ? 20 : _options$mouseWheel$s,
        _options$mouseWheel$i = _options$mouseWheel.invert,
        invert = _options$mouseWheel$i === undefined ? false : _options$mouseWheel$i,
        _options$mouseWheel$e = _options$mouseWheel.easeTime,
        easeTime = _options$mouseWheel$e === undefined ? 300 : _options$mouseWheel$e;


    clearTimeout(this.mouseWheelTimer);
    this.mouseWheelTimer = setTimeout(function () {
      if (!_this2.options.snap && !easeTime) {
        _this2.trigger('scrollEnd', {
          x: _this2.x,
          y: _this2.y
        });
      }
      _this2.firstWheelOpreation = true;
    }, 400);

    var wheelDeltaX = void 0;
    var wheelDeltaY = void 0;

    switch (true) {
      case 'deltaX' in e:
        if (e.deltaMode === 1) {
          wheelDeltaX = -e.deltaX * speed;
          wheelDeltaY = -e.deltaY * speed;
        } else {
          wheelDeltaX = -e.deltaX;
          wheelDeltaY = -e.deltaY;
        }
        break;
      case 'wheelDeltaX' in e:
        wheelDeltaX = e.wheelDeltaX / 120 * speed;
        wheelDeltaY = e.wheelDeltaY / 120 * speed;
        break;
      case 'wheelDelta' in e:
        wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * speed;
        break;
      case 'detail' in e:
        wheelDeltaX = wheelDeltaY = -e.detail / 3 * speed;
        break;
      default:
        return;
    }

    var direction = invert ? -1 : 1;
    wheelDeltaX *= direction;
    wheelDeltaY *= direction;

    if (!this.hasVerticalScroll) {
      wheelDeltaX = wheelDeltaY;
      wheelDeltaY = 0;
    }

    var newX = void 0;
    var newY = void 0;
    if (this.options.snap) {
      newX = this.currentPage.pageX;
      newY = this.currentPage.pageY;

      if (wheelDeltaX > 0) {
        newX--;
      } else if (wheelDeltaX < 0) {
        newX++;
      }

      if (wheelDeltaY > 0) {
        newY--;
      } else if (wheelDeltaY < 0) {
        newY++;
      }

      this._goToPage(newX, newY);
      return;
    }

    newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
    newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

    this.movingDirectionX = this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
    this.movingDirectionY = this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

    if (newX > this.minScrollX) {
      newX = this.minScrollX;
    } else if (newX < this.maxScrollX) {
      newX = this.maxScrollX;
    }

    if (newY > this.minScrollY) {
      newY = this.minScrollY;
    } else if (newY < this.maxScrollY) {
      newY = this.maxScrollY;
    }

    var needTriggerEnd = this.y === newY;
    this.scrollTo(newX, newY, easeTime, ease.swipe);
    this.trigger('scroll', {
      x: this.x,
      y: this.y
    });
    clearTimeout(this.mouseWheelEndTimer);
    if (needTriggerEnd) {
      this.mouseWheelEndTimer = setTimeout(function () {
        _this2.trigger('scrollEnd', {
          x: _this2.x,
          y: _this2.y
        });
      }, easeTime);
    }
  };
}

function zoomMixin(BScroll) {
  BScroll.prototype._initZoom = function () {
    var _options$zoom = this.options.zoom,
        _options$zoom$start = _options$zoom.start,
        start = _options$zoom$start === undefined ? 1 : _options$zoom$start,
        _options$zoom$min = _options$zoom.min,
        min = _options$zoom$min === undefined ? 1 : _options$zoom$min,
        _options$zoom$max = _options$zoom.max,
        max = _options$zoom$max === undefined ? 4 : _options$zoom$max;

    this.scale = Math.min(Math.max(start, min), max);
    this.setScale(this.scale);
    this.scrollerStyle[style.transformOrigin] = '0 0';
  };

  BScroll.prototype._zoomTo = function (scale, originX, originY, startScale) {
    this.scaled = true;

    var lastScale = scale / (startScale || this.scale);
    this.setScale(scale);

    this.refresh();

    var newX = Math.round(this.startX - (originX - this.relativeX) * (lastScale - 1));
    var newY = Math.round(this.startY - (originY - this.relativeY) * (lastScale - 1));

    if (newX > this.minScrollX) {
      newX = this.minScrollX;
    } else if (newX < this.maxScrollX) {
      newX = this.maxScrollX;
    }

    if (newY > this.minScrollY) {
      newY = this.minScrollY;
    } else if (newY < this.maxScrollY) {
      newY = this.maxScrollY;
    }

    if (this.x !== newX || this.y !== newY) {
      this.scrollTo(newX, newY, this.options.bounceTime);
    }

    this.scaled = false;
  };

  BScroll.prototype.zoomTo = function (scale, x, y) {
    var _offsetToBody = offsetToBody(this.wrapper),
        left = _offsetToBody.left,
        top = _offsetToBody.top;

    var originX = x + left - this.x;
    var originY = y + top - this.y;
    this._zoomTo(scale, originX, originY);
  };

  BScroll.prototype._zoomStart = function (e) {
    var firstFinger = e.touches[0];
    var secondFinger = e.touches[1];
    var deltaX = Math.abs(firstFinger.pageX - secondFinger.pageX);
    var deltaY = Math.abs(firstFinger.pageY - secondFinger.pageY);

    this.startDistance = getDistance(deltaX, deltaY);
    this.startScale = this.scale;

    var _offsetToBody2 = offsetToBody(this.wrapper),
        left = _offsetToBody2.left,
        top = _offsetToBody2.top;

    this.originX = Math.abs(firstFinger.pageX + secondFinger.pageX) / 2 + left - this.x;
    this.originY = Math.abs(firstFinger.pageY + secondFinger.pageY) / 2 + top - this.y;

    this.trigger('zoomStart');
  };

  BScroll.prototype._zoom = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }

    if (this.options.preventDefault) {
      e.preventDefault();
    }

    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    var firstFinger = e.touches[0];
    var secondFinger = e.touches[1];
    var deltaX = Math.abs(firstFinger.pageX - secondFinger.pageX);
    var deltaY = Math.abs(firstFinger.pageY - secondFinger.pageY);
    var distance = getDistance(deltaX, deltaY);
    var scale = distance / this.startDistance * this.startScale;

    this.scaled = true;

    var _options$zoom2 = this.options.zoom,
        _options$zoom2$min = _options$zoom2.min,
        min = _options$zoom2$min === undefined ? 1 : _options$zoom2$min,
        _options$zoom2$max = _options$zoom2.max,
        max = _options$zoom2$max === undefined ? 4 : _options$zoom2$max;


    if (scale < min) {
      scale = 0.5 * min * Math.pow(2.0, scale / min);
    } else if (scale > max) {
      scale = 2.0 * max * Math.pow(0.5, max / scale);
    }

    var lastScale = scale / this.startScale;

    var x = this.startX - (this.originX - this.relativeX) * (lastScale - 1);
    var y = this.startY - (this.originY - this.relativeY) * (lastScale - 1);

    this.setScale(scale);

    this.scrollTo(x, y, 0);
  };

  BScroll.prototype._zoomEnd = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }

    if (this.options.preventDefault) {
      e.preventDefault();
    }

    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    this.isInTransition = false;
    this.isAnimating = false;
    this.initiated = 0;

    var _options$zoom3 = this.options.zoom,
        _options$zoom3$min = _options$zoom3.min,
        min = _options$zoom3$min === undefined ? 1 : _options$zoom3$min,
        _options$zoom3$max = _options$zoom3.max,
        max = _options$zoom3$max === undefined ? 4 : _options$zoom3$max;


    var scale = this.scale > max ? max : this.scale < min ? min : this.scale;

    this._zoomTo(scale, this.originX, this.originY, this.startScale);

    this.trigger('zoomEnd');
  };
}

// import { ease } from '../util/ease'

// Number of items to instantiate beyond current view in the scroll direction.
var RUNWAY_ITEMS = 30;

// Number of items to instantiate beyond current view in the opposite direction.
var RUNWAY_ITEMS_OPPOSITE = 10;

// The animation interval (in ms) for fading in content from tombstones.
var ANIMATION_DURATION_MS = 200;

// The number of pixels of default additional length to allow scrolling to.
var DEFAULT_SCROLL_RUNWAY = 2000;

function infiniteMixin(BScroll) {
  BScroll.prototype._initInfinite = function () {
    this.options.probeType = 3;
    this.maxScrollY = -DEFAULT_SCROLL_RUNWAY;
    this.infiniteScroller = new InfiniteScroller(this, this.options.infinity);
  };
}

function isTombstoneNode(node) {
  if (node && node.classList) {
    return node.classList.contains('tombstone');
  }
}

function InfiniteScroller(scroller, options) {
  var _this = this;

  this.options = options;
  assert(typeof this.options.createTombstone === 'function', 'Infinite scroll need createTombstone Function to create tombstone');

  assert(typeof this.options.fetch === 'function', 'Infinite scroll need fetch Function to fetch new data.');

  assert(typeof this.options.render === 'function', 'Infinite scroll need render Function to render each item.');

  this.firstAttachedItem = 0;
  this.lastAttachedItem = 0;

  this.anchorScrollTop = 0;
  this.anchorItem = {
    index: 0,
    offset: 0
  };
  this.tombstoneHeight = 0;
  this.tombstoneWidth = 0;
  this.tombstones = [];
  this.tombstonesAnimationHandlers = [];

  this.items = [];
  this.loadedItems = 0;
  this.requestInProgress = false;
  this.hasMore = true;

  this.scroller = scroller;
  this.wrapperEl = this.scroller.wrapper;
  this.scrollerEl = this.scroller.scroller;

  this.scroller.on('resize', function () {
    _this.onResize();
  });
  this.scroller.on('destroy', function () {
    _this.destroy();
  });

  // wait scroll core init
  this._onResizeHandler = setTimeout(function () {
    _this.onResize();

    // must wait tombstoneHeight has size
    _this.scroller.on('scroll', function () {
      _this.onScroll();
    });
  });
}

InfiniteScroller.prototype.destroy = function () {
  var _this2 = this;

  // In extreme scene, destroy is triggered before _onResizeHandler
  clearTimeout(this._onResizeHandler);
  this.tombstonesAnimationHandlers.forEach(function (handler) {
    clearTimeout(handler);
  });
  this.tombstonesAnimationHandlers = null;
  this.items.forEach(function (item) {
    if (item.node) {
      _this2.scrollerEl.removeChild(item.node);
      item.node = null;
    }
  });
  this.scroller.infiniteScroller = null;
  this.scroller = null;
  this.wrapperEl = null;
  this.scrollerEl = null;
  this.items = null;
  this.tombstones = null;
};

InfiniteScroller.prototype.onScroll = function () {
  var scrollTop = -this.scroller.y;
  var delta = scrollTop - this.anchorScrollTop;
  if (scrollTop === 0) {
    this.anchorItem = {
      index: 0,
      offset: 0
    };
  } else {
    this.anchorItem = this._calculateAnchoredItem(this.anchorItem, delta);
  }

  this.anchorScrollTop = scrollTop;
  var lastScreenItem = this._calculateAnchoredItem(this.anchorItem, this.scroller.wrapperHeight);

  var start = this.anchorItem.index;
  var end = lastScreenItem.index;
  if (delta < 0) {
    start -= RUNWAY_ITEMS;
    end += RUNWAY_ITEMS_OPPOSITE;
  } else {
    start -= RUNWAY_ITEMS_OPPOSITE;
    end += RUNWAY_ITEMS;
  }
  this.fill(start, end);
  this.maybeRequestContent();
};

InfiniteScroller.prototype.onResize = function () {
  var tombstone = this.options.createTombstone();
  tombstone.style.position = 'absolute';
  this.scrollerEl.appendChild(tombstone);
  tombstone.style.display = '';
  this.tombstoneHeight = tombstone.offsetHeight;
  this.tombstoneWidth = tombstone.offsetWidth;
  this.scrollerEl.removeChild(tombstone);

  for (var i = 0; i < this.items.length; i++) {
    this.items[i].height = this.items[i].width = 0;
  }

  this.onScroll();
};

InfiniteScroller.prototype.fill = function (start, end) {
  this.firstAttachedItem = Math.max(0, start);
  if (!this.hasMore) {
    end = Math.min(end, this.items.length);
  }
  this.lastAttachedItem = end;
  this.attachContent();
};

InfiniteScroller.prototype.maybeRequestContent = function () {
  var _this3 = this;

  if (this.requestInProgress || !this.hasMore) {
    return;
  }
  var itemsNeeded = this.lastAttachedItem - this.loadedItems;
  if (itemsNeeded <= 0) {
    return;
  }
  this.requestInProgress = true;
  this.options.fetch(itemsNeeded).then(function (items) {
    _this3.requestInProgress = false;
    if (items) {
      _this3.addContent(items);
    } else {
      _this3.hasMore = false;
      var tombstoneLen = _this3._removeTombstones();
      var curPos = 0;
      if (_this3.anchorItem.index <= _this3.items.length) {
        curPos = _this3._fixScrollPosition();
        _this3._setupAnimations({}, curPos);
        _this3.scroller.resetPosition(_this3.scroller.options.bounceTime);
      } else {
        _this3.anchorItem.index -= tombstoneLen;
        curPos = _this3._fixScrollPosition();
        _this3._setupAnimations({}, curPos);
        _this3.scroller.stop();
        _this3.scroller.resetPosition();
        _this3.onScroll();
      }
    }
  });
};

InfiniteScroller.prototype.addContent = function (items) {
  for (var i = 0; i < items.length; i++) {
    if (this.items.length <= this.loadedItems) {
      this._addItem();
    }
    this.items[this.loadedItems++].data = items[i];
  }
  this.attachContent();
  this.maybeRequestContent();
};

InfiniteScroller.prototype.attachContent = function () {
  var unusedNodes = this._collectUnusedNodes();
  var tombstoneAnimations = this._createDOMNodes(unusedNodes);
  this._cleanupUnusedNodes(unusedNodes);
  this._cacheNodeSize();
  var curPos = this._fixScrollPosition();
  this._setupAnimations(tombstoneAnimations, curPos);
};

InfiniteScroller.prototype.resetMore = function () {
  this.hasMore = true;
};

InfiniteScroller.prototype._removeTombstones = function () {
  var markIndex = void 0;
  var tombstoneLen = 0;
  var itemLen = this.items.length;
  for (var i = 0; i < itemLen; i++) {
    var currentNode = this.items[i].node;
    var currentData = this.items[i].data;
    if ((!currentNode || isTombstoneNode(currentNode)) && !currentData) {
      // 0 should be excluded
      if (markIndex === void 0) {
        markIndex = i;
      }
      if (currentNode) {
        this.scrollerEl.removeChild(currentNode);
      }
    }
  }
  tombstoneLen = itemLen - markIndex;
  this.items.splice(markIndex);
  this.lastAttachedItem = Math.min(this.lastAttachedItem, this.items.length);
  return tombstoneLen;
};

InfiniteScroller.prototype._collectUnusedNodes = function () {
  var unusedNodes = [];
  for (var i = 0; i < this.items.length; i++) {
    // Skip the items which should be visible.
    if (i === this.firstAttachedItem) {
      i = this.lastAttachedItem - 1;
      continue;
    }
    var currentNode = this.items[i].node;
    if (currentNode) {
      if (isTombstoneNode(currentNode)) {
        // Cache tombstones for reuse
        this.tombstones.push(currentNode);
        this.tombstones[this.tombstones.length - 1].style.display = 'none';
      } else {
        unusedNodes.push(currentNode);
      }
    }
    this.items[i].node = null;
  }
  return unusedNodes;
};

InfiniteScroller.prototype._createDOMNodes = function (unusedNodes) {
  var tombstoneAnimations = {};
  for (var i = this.firstAttachedItem; i < this.lastAttachedItem; i++) {
    while (this.items.length <= i) {
      this._addItem();
    }
    var currentNode = this.items[i].node;
    var currentData = this.items[i].data;
    if (currentNode) {
      if (isTombstoneNode(currentNode) && currentData) {
        currentNode.style.zIndex = 1;
        tombstoneAnimations[i] = [currentNode, this.items[i].top - this.anchorScrollTop];
        this.items[i].node = null;
      } else {
        continue;
      }
    }
    var node = currentData ? this.options.render(currentData, unusedNodes.pop()) : this._getTombStone();
    node.style.position = 'absolute';
    this.items[i].top = -1;
    this.scrollerEl.appendChild(node);
    this.items[i].node = node;
  }
  return tombstoneAnimations;
};

InfiniteScroller.prototype._cleanupUnusedNodes = function (unusedNodes) {
  while (unusedNodes.length) {
    this.scrollerEl.removeChild(unusedNodes.pop());
  }
};

InfiniteScroller.prototype._cacheNodeSize = function () {
  for (var i = this.firstAttachedItem; i < this.lastAttachedItem; i++) {
    var item = this.items[i];
    // Only cache the height if we have the real contents, not a placeholder.
    if (item.data && !item.height) {
      var isTombstone = isTombstoneNode(item.node);
      item.height = isTombstone ? this.tombstoneHeight : item.node.offsetHeight;
      item.width = isTombstone ? this.tombstoneWidth : item.node.offsetWidth;
    }
  }
};

InfiniteScroller.prototype._fixScrollPosition = function () {
  this.anchorScrollTop = 0;
  for (var _i = 0; _i < this.anchorItem.index; _i++) {
    this.anchorScrollTop += this.items[_i].height || this.tombstoneHeight;
  }
  this.anchorScrollTop += this.anchorItem.offset;

  // Position all nodes.
  var curPos = this.anchorScrollTop - this.anchorItem.offset;
  var i = this.anchorItem.index;
  while (i > this.firstAttachedItem) {
    curPos -= this.items[i - 1].height || this.tombstoneHeight;
    i--;
  }

  return curPos;
};

InfiniteScroller.prototype._setupAnimations = function (tombstoneAnimations, curPos) {
  var _this4 = this;

  for (var i in tombstoneAnimations) {
    var animation = tombstoneAnimations[i];
    this.items[i].node.style[style.transform] = 'translateY(' + (this.anchorScrollTop + animation[1]) + 'px) scale(' + this.tombstoneWidth / this.items[i].width + ', ' + this.tombstoneHeight / this.items[i].height + ')';
    // Call offsetTop on the nodes to be animated to force them to apply current transforms.
    /* eslint-disable no-unused-expressions */
    this.items[i].node.offsetTop;
    animation[0].offsetTop;
    this.items[i].node.style[style.transition] = cssVendor + 'transform ' + ANIMATION_DURATION_MS + 'ms';
  }

  for (var _i2 = this.firstAttachedItem; _i2 < this.lastAttachedItem; _i2++) {
    var _animation = tombstoneAnimations[_i2];
    if (_animation) {
      var tombstoneNode = _animation[0];
      tombstoneNode.style[style.transition] = cssVendor + 'transform ' + ANIMATION_DURATION_MS + 'ms, opacity ' + ANIMATION_DURATION_MS + 'ms';
      tombstoneNode.style[style.transform] = 'translateY(' + curPos + 'px) scale(' + this.items[_i2].width / this.tombstoneWidth + ', ' + this.items[_i2].height / this.tombstoneHeight + ')';
      tombstoneNode.style.opacity = 0;
    }
    if (curPos !== this.items[_i2].top) {
      if (!_animation) {
        this.items[_i2].node.style[style.transition] = '';
      }
      this.items[_i2].node.style[style.transform] = 'translateY(' + curPos + 'px)';
    }
    this.items[_i2].top = curPos;
    curPos += this.items[_i2].height || this.tombstoneHeight;
  }

  this.scroller.maxScrollY = -(curPos - this.scroller.wrapperHeight + (this.hasMore ? DEFAULT_SCROLL_RUNWAY : 0));

  var tombstoneAnimationsHandler = setTimeout(function () {
    for (var _i3 in tombstoneAnimations) {
      var _animation2 = tombstoneAnimations[_i3];
      _animation2[0].style.display = 'none';
      // Tombstone can be recycled now.
      _this4.tombstones.push(_animation2[0]);
    }
  }, ANIMATION_DURATION_MS);

  this.tombstonesAnimationHandlers.push(tombstoneAnimationsHandler);
};

InfiniteScroller.prototype._getTombStone = function () {
  var tombstone = this.tombstones.pop();
  if (tombstone) {
    tombstone.style.display = '';
    tombstone.style.opacity = 1;
    tombstone.style[style.transform] = '';
    tombstone.style[style.transition] = '';
    return tombstone;
  }
  return this.options.createTombstone();
};

InfiniteScroller.prototype._addItem = function () {
  this.items.push({
    data: null,
    node: null,
    height: 0,
    width: 0,
    top: 0
  });
};

InfiniteScroller.prototype._calculateAnchoredItem = function (initialAnchor, delta) {
  if (delta === 0) {
    return initialAnchor;
  }
  var i = initialAnchor.index;
  var tombstones = 0;

  delta += initialAnchor.offset;
  if (delta < 0) {
    while (delta < 0 && i > 0 && this.items[i - 1].height) {
      delta += this.items[i - 1].height;
      i--;
    }
    tombstones = Math.max(-i, Math.ceil(Math.min(delta, 0) / this.tombstoneHeight));
  } else {
    while (delta > 0 && i < this.items.length && this.items[i].height && this.items[i].height < delta) {
      delta -= this.items[i].height;
      i++;
    }
    if (i >= this.items.length || !this.items[i].height) {
      tombstones = Math.floor(Math.max(delta, 0) / this.tombstoneHeight);
    }
  }
  i += tombstones;
  delta -= tombstones * this.tombstoneHeight;

  return {
    index: i,
    offset: delta
  };
};

function BScroll(el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  if (!this.wrapper) {
    warn('Can not resolve the wrapper DOM.');
  }
  this.scroller = this.wrapper.children[0];
  if (!this.scroller) {
    warn('The wrapper need at least one child element to be scroller.');
  }
  // cache style for better performance
  this.scrollerStyle = this.scroller.style;

  this._init(options);
}

initMixin(BScroll);
coreMixin(BScroll);
eventMixin(BScroll);
snapMixin(BScroll);
wheelMixin(BScroll);
scrollbarMixin(BScroll);
pullDownMixin(BScroll);
pullUpMixin(BScroll);
mouseWheelMixin(BScroll);
zoomMixin(BScroll);
infiniteMixin(BScroll);

BScroll.Version = '1.15.2';

/* harmony default export */ __webpack_exports__["a"] = (BScroll);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"scroll"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_PositionBox_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_53eef0e1_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_PositionBox_vue__ = __webpack_require__(34);
function injectStyle (ssrContext) {
  __webpack_require__(32)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53eef0e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_PositionBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_53eef0e1_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_PositionBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(33);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("47ec1441", content, true, {});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".position-box[data-v-53eef0e1]{background:#f6f6f6;padding-bottom:10px}.position-box>.hostory[data-v-53eef0e1]{height:85px;padding:15px 10px 0;box-sizing:border-box}.position-box>.hostory>p[data-v-53eef0e1]{line-height:30px;color:#847d7d}.position-box>.hostory>.citybox[data-v-53eef0e1]{height:40px;box-sizing:border-box;padding-top:5px}.position-box>.hostory>.citybox>button[data-v-53eef0e1]{box-sizing:border-box;border-radius:4px;height:30px;margin:0;background:#fdfdfd;color:#666;float:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;display:flex;flex-direction:row;justify-content:center;align-items:center;outline:none;border:none}.position-box>.hostory>.citybox>button>.icon[data-v-53eef0e1]{color:#119dfc}", ""]);

// exports


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-box"},[_c('div',{staticClass:"hostory"},[_c('p',[_vm._v("当前定位")]),_vm._v(" "),_c('div',{staticClass:"citybox"},[_c('button',{staticStyle:{"text-align":"center"},on:{"click":function($event){return _vm.changeCity(_vm.location)}}},[_c('i',{staticClass:"iconfont icon-tubiao- icon",staticStyle:{"margin":"0px auto"}},[_c('a',{staticStyle:{"color":"#666","font-size":"14px"}},[_vm._v(_vm._s(_vm.location.cityName))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_CityList_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_180e3e24_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_CityList_vue__ = __webpack_require__(38);
function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-180e3e24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_CityList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_180e3e24_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_CityList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(37);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a039e90c", content, true, {});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".lists[data-v-180e3e24]{width:100%;background:#fff}.lists div .city-title[data-v-180e3e24]{height:30px;border-top:1px solid #f6f6f6;background:#f6f6f6;line-height:30px;padding-left:10px}.lists div .city-item[data-v-180e3e24]{margin:0 10px;height:35px;line-height:35px;border-bottom:1px solid #f6f6f6}.lists div .city-item[data-v-180e3e24]:last-child{border:none}.hotCity[data-v-180e3e24]{height:120px;width:100%;background:#fff}.hot-city-title[data-v-180e3e24]{height:30px;border-top:1px solid #f6f6f6;background:#f6f6f6;line-height:30px;padding-left:10px}.hot-city-button[data-v-180e3e24]{box-sizing:border-box;border-radius:4px;height:40px;margin-top:6px;margin-right:6px;background:#fdfdfd;color:#666;float:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;display:flex;flex-direction:row;justify-content:center;align-items:center;outline:none;border:none}", ""]);

// exports


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hotCity"},[_c('div',{staticClass:"hot-city-title"},[_vm._v("热门城市")]),_vm._v(" "),_vm._l((_vm.hotCityList),function(city){return _c('div',{key:city.cityCode,on:{"click":function($event){return _vm.changeCity(city)}}},[_c('button',{staticClass:"hot-city-button"},[_vm._v(_vm._s(city.cityName))])])})],2),_vm._v(" "),_c('div',{staticClass:"lists"},_vm._l((_vm.citylist),function(citys){return _c('div',{key:citys[0],attrs:{"dataNum":citys[1].length}},[_c('p',{ref:citys[0],refInFor:true,staticClass:"city-title"},[_vm._v(_vm._s(citys[0]))]),_vm._v(" "),_vm._l((citys[1]),function(city){return _c('p',{key:city.cityCode,staticClass:"city-item",on:{"click":function($event){return _vm.changeCity(city)}}},[_vm._v(_vm._s(city.cityName))])})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_NavList_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0a7cf3a6_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_NavList_vue__ = __webpack_require__(42);
function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a7cf3a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_NavList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0a7cf3a6_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_NavList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(41);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3fe6229b", content, true, {});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".navbody[data-v-0a7cf3a6]{width:20px;border-radius:10px;height:480px;position:absolute;top:50%;right:0;margin-top:-230px;z-index:95;box-sizing:border-box;padding:10px 0}.navbody .navItem[data-v-0a7cf3a6]{font-size:16px;color:#777}.navbody .flagItem[data-v-0a7cf3a6],.navbody .navItem[data-v-0a7cf3a6]{width:20px;height:20px;text-align:center;line-height:20px;user-select:none}.navbody .flagItem[data-v-0a7cf3a6]{font-size:14px;color:#fff;background:rgba(0,0,0,.5);border-radius:10px}", ""]);

// exports


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbody"},[_c('div',{staticClass:"navList",on:{"touchstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.start($event)},"touchmove":function($event){$event.stopPropagation();$event.preventDefault();return _vm.move($event)}}},_vm._l((_vm.navList),function(item){return _c('div',{key:item,class:_vm.navClass(item),attrs:{"data-name":item}},[_vm._v(_vm._s(item))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MaskBox_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_641ce170_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_MaskBox_vue__ = __webpack_require__(46);
function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-641ce170"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MaskBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_641ce170_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_MaskBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(45);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("dc9c67fe", content, true, {});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".mask-box .mask-body[data-v-641ce170],.mask-box[data-v-641ce170]{width:100%;height:100%;position:absolute;top:0;left:0}.mask-box .mask-body[data-v-641ce170]{background:#000;opacity:.2;z-index:200}.mask-box .btn-box[data-v-641ce170]{width:300px;height:155px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;background:#fff;z-index:300;border-radius:8px}.mask-box .btn-box .message[data-v-641ce170]{width:100%;height:108px;border-radius:8px 8px 0 0;line-height:22px;text-align:center;border-bottom:2px solid #666;float:left;display:flex;flex-direction:column;justify-content:space-around;align-items:center}.mask-box .btn-box .message p[data-v-641ce170]{font-size:22px;font-weight:900}.mask-box .btn-box .btn-left[data-v-641ce170]{width:149px;height:45px;border-radius:0 0 0 8px;border-right:1px solid #666;text-align:center;line-height:45px;float:left}.mask-box .btn-box .btn-left p[data-v-641ce170]{font-size:16px;font-weight:900;text-align:center}.mask-box .btn-box .btn-right[data-v-641ce170]{width:149px;height:45px;border-radius:0 0 8px 0;border-left:1px solid #666;text-align:center;line-height:45px;float:left}.mask-box .btn-box .btn-right p[data-v-641ce170]{font-size:16px;font-weight:900;text-align:center}", ""]);

// exports


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_SearchList_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_020ea939_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_SearchList_vue__ = __webpack_require__(54);
function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-020ea939"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_SearchList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_020ea939_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_SearchList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(49);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5c5f8d95", content, true, {});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".listbody[data-v-020ea939]{width:100%;height:calc(100% - 45px);background:#f5f5f5;position:absolute;z-index:100}", ""]);

// exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_CityItem_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_dea325dc_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_CityItem_vue__ = __webpack_require__(53);
function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dea325dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_CityItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_dea325dc_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_CityItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(52);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0df70535", content, true, {});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".listbox[data-v-dea325dc]{width:100%;background:#fff}.listbox .city-search-item[data-v-dea325dc]{background:#fff;margin:0 10px;height:35px;line-height:35px;border-bottom:1px solid #f6f6f6;box-sizing:border-box}.listbox .city-search-item[data-v-dea325dc]:last-child{border:none}", ""]);

// exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listbox"},_vm._l((_vm.searchListContent),function(city){return _c('p',{key:city.cityCode,staticClass:"city-search-item",on:{"click":function($event){return _vm.changeCity(city)}}},[_vm._v(_vm._s(city.cityName))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listbody"},[_c('scroll',{attrs:{"data":_vm.searchListContent}},[_c('div',[_c('city-item',{attrs:{"search-list-content":_vm.searchListContent},on:{"changeName":_vm.changeCity}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSearchList; });
var getSearchList = function getSearchList(text, list, canSearchSpell) {
  var reg1 = /^\w+$/g;
  var reg2 = new RegExp('^' + text, 'g');
  var reg3 = new RegExp('^[\\u4E00-\\u9FFF]{1,}$', 'g');
  var reg4 = new RegExp('^' + text, 'g');
  var resList = [];
  if (text.match(reg1) && canSearchSpell) {
    for (var i = 0, len1 = list.length; i < len1; i++) {
      for (var j = 0, len2 = list[i][1].length; j < len2; j++) {
        console.log("search", list[i][1][j].regionNamePinyin);
        if (list[i][1][j].regionNamePinyin.match(reg2)) {
          resList.push(list[i][1][j]);
        }
      }
    }
  } else {
    if (reg3.test(text)) {
      for (var _i = 0, _len = list.length; _i < _len; _i++) {
        for (var _j = 0, _len2 = list[_i][1].length; _j < _len2; _j++) {
          if (list[_i][1][_j].cityName.match(reg4)) {
            resList.push(list[_i][1][_j]);
          }
        }
      }
    }
  }
  return resList;
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openCityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hotCityList; });
var openCityList = [["A", [{
    "cityCode": "152900",
    "cityName": "阿拉善盟",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130734095206793219",
    "countyCode": null,
    "regionNamePinyin": "alashanmeng",
    "regionNameInitial": "A"
}, {
    "cityCode": "210300",
    "cityName": "鞍山市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130734101787656194",
    "countyCode": null,
    "regionNamePinyin": "anshanshi",
    "regionNameInitial": "A"
}, {
    "cityCode": "340800",
    "cityName": "安庆市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734027154210817",
    "countyCode": null,
    "regionNamePinyin": "anqingshi",
    "regionNameInitial": "A"
}, {
    "cityCode": "410500",
    "cityName": "安阳市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130733981742481410",
    "countyCode": null,
    "regionNamePinyin": "anyangshi",
    "regionNameInitial": "A"
}, {
    "cityCode": "513200",
    "cityName": "阿坝藏族羌族自治州",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734064890363905",
    "countyCode": null,
    "regionNamePinyin": "abacangzuqiangzuzizhizhou",
    "regionNameInitial": "A"
}, {
    "cityCode": "520400",
    "cityName": "安顺市",
    "provinceCode": "520000",
    "provinceName": "贵州省",
    "id": "1130734073849397250",
    "countyCode": null,
    "regionNamePinyin": "anshunshi",
    "regionNameInitial": "A"
}, {
    "cityCode": "542500",
    "cityName": "阿里地区",
    "provinceCode": "540000",
    "provinceName": "西藏自治区",
    "id": "1130734094594424834",
    "countyCode": null,
    "regionNamePinyin": "alidiqu",
    "regionNameInitial": "A"
}, {
    "cityCode": "610900",
    "cityName": "安康市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130733969084071937",
    "countyCode": null,
    "regionNamePinyin": "ankangshi",
    "regionNameInitial": "A"
}, {
    "cityCode": "652900",
    "cityName": "阿克苏地区",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734092820234242",
    "countyCode": null,
    "regionNamePinyin": "akesudiqu",
    "regionNameInitial": "A"
}, {
    "cityCode": "654300",
    "cityName": "阿勒泰地区",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130733991536181250",
    "countyCode": null,
    "regionNamePinyin": "aletaidiqu",
    "regionNameInitial": "A"
}, {
    "cityCode": "659002",
    "cityName": "阿拉尔市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734022871826441",
    "countyCode": null,
    "regionNamePinyin": "alaershi",
    "regionNameInitial": "A"
}, {
    "cityCode": "820000",
    "cityName": "澳门特别行政区",
    "provinceCode": "820000",
    "provinceName": "澳门特别行政区",
    "id": "1130733988944101378",
    "countyCode": null,
    "regionNamePinyin": "aomentebiexingzhengqu",
    "regionNameInitial": "A"
}]], ["B", [{
    "cityCode": "110000",
    "cityName": "北京市",
    "provinceCode": "110000",
    "provinceName": "北京市",
    "id": "1130734065938939906",
    "countyCode": null,
    "regionNamePinyin": "beijingshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "130600",
    "cityName": "保定市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130734047060377602",
    "countyCode": null,
    "regionNamePinyin": "baodingshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "150200",
    "cityName": "包头市",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130734054509461505",
    "countyCode": null,
    "regionNamePinyin": "baotoushi",
    "regionNameInitial": "B"
}, {
    "cityCode": "150800",
    "cityName": "巴彦淖尔市",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130733991313883138",
    "countyCode": null,
    "regionNamePinyin": "bayannaoershi",
    "regionNameInitial": "B"
}, {
    "cityCode": "210500",
    "cityName": "本溪市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130734071290871809",
    "countyCode": null,
    "regionNamePinyin": "benxishi",
    "regionNameInitial": "B"
}, {
    "cityCode": "220600",
    "cityName": "白山市",
    "provinceCode": "220000",
    "provinceName": "吉林省",
    "id": "1130734046389288962",
    "countyCode": null,
    "regionNamePinyin": "baishanshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "220800",
    "cityName": "白城市",
    "provinceCode": "220000",
    "provinceName": "吉林省",
    "id": "1130733990667960322",
    "countyCode": null,
    "regionNamePinyin": "baichengshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "340300",
    "cityName": "蚌埠市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734096918069249",
    "countyCode": null,
    "regionNamePinyin": "bengbushi",
    "regionNameInitial": "B"
}, {
    "cityCode": "341600",
    "cityName": "亳州市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734098444795905",
    "countyCode": null,
    "regionNamePinyin": "bozhoushi",
    "regionNameInitial": "B"
}, {
    "cityCode": "371600",
    "cityName": "滨州市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734055063109633",
    "countyCode": null,
    "regionNamePinyin": "binzhoushi",
    "regionNameInitial": "B"
}, {
    "cityCode": "450500",
    "cityName": "北海市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130733988491116545",
    "countyCode": null,
    "regionNamePinyin": "beihaishi",
    "regionNameInitial": "B"
}, {
    "cityCode": "451000",
    "cityName": "百色市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130733983680249858",
    "countyCode": null,
    "regionNamePinyin": "baiseshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "469025",
    "cityName": "白沙黎族自治县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733974255648770",
    "countyCode": null,
    "regionNamePinyin": "baishalizuzizhixian",
    "regionNameInitial": "B"
}, {
    "cityCode": "469029",
    "cityName": "保亭黎族苗族自治县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733974893182978",
    "countyCode": null,
    "regionNamePinyin": "baotinglizumiaozuzizhixian",
    "regionNameInitial": "B"
}, {
    "cityCode": "511900",
    "cityName": "巴中市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130733989443223554",
    "countyCode": null,
    "regionNamePinyin": "bazhongshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "520500",
    "cityName": "毕节市",
    "provinceCode": "520000",
    "provinceName": "贵州省",
    "id": "1130734064093446146",
    "countyCode": null,
    "regionNamePinyin": "bijieshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "530500",
    "cityName": "保山市",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130734093453574146",
    "countyCode": null,
    "regionNamePinyin": "baoshanshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "610300",
    "cityName": "宝鸡市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130734074340130817",
    "countyCode": null,
    "regionNamePinyin": "baojishi",
    "regionNameInitial": "B"
}, {
    "cityCode": "620400",
    "cityName": "白银市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130734098398658562",
    "countyCode": null,
    "regionNamePinyin": "baiyinshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "652700",
    "cityName": "博尔塔拉蒙古自治州",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130733965162397697",
    "countyCode": null,
    "regionNamePinyin": "boertalamengguzizhizhou",
    "regionNameInitial": "B"
}, {
    "cityCode": "652800",
    "cityName": "巴音郭楞蒙古自治州",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734098025365505",
    "countyCode": null,
    "regionNamePinyin": "bayinguolengmengguzizhizhou",
    "regionNameInitial": "B"
}, {
    "cityCode": "659005",
    "cityName": "北屯市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734022871826437",
    "countyCode": null,
    "regionNamePinyin": "beitunshi",
    "regionNameInitial": "B"
}]], ["C", [{
    "cityCode": "130800",
    "cityName": "承德市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130734082011512833",
    "countyCode": null,
    "regionNamePinyin": "chengdeshi",
    "regionNameInitial": "C"
}, {
    "cityCode": "130900",
    "cityName": "沧州市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130733979553054721",
    "countyCode": null,
    "regionNamePinyin": "cangzhoushi",
    "regionNameInitial": "C"
}, {
    "cityCode": "140400",
    "cityName": "长治市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130733964134793218",
    "countyCode": null,
    "regionNamePinyin": "changzhishi",
    "regionNameInitial": "C"
}, {
    "cityCode": "150400",
    "cityName": "赤峰市",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130734083894755330",
    "countyCode": null,
    "regionNamePinyin": "chifengshi",
    "regionNameInitial": "C"
}, {
    "cityCode": "211300",
    "cityName": "朝阳市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130733972494041089",
    "countyCode": null,
    "regionNamePinyin": "chaoyangshi",
    "regionNameInitial": "C"
}, {
    "cityCode": "220100",
    "cityName": "长春市",
    "provinceCode": "220000",
    "provinceName": "吉林省",
    "id": "1130734027787550722",
    "countyCode": null,
    "regionNamePinyin": "changchunshi",
    "regionNameInitial": "C"
}, {
    "cityCode": "320400",
    "cityName": "常州市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130733960536080385",
    "countyCode": null,
    "regionNamePinyin": "changzhoushi",
    "regionNameInitial": "C"
}, {
    "cityCode": "341100",
    "cityName": "滁州市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130733999769600001",
    "countyCode": null,
    "regionNamePinyin": "chuzhoushi",
    "regionNameInitial": "C"
}, {
    "cityCode": "341700",
    "cityName": "池州市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734055306379266",
    "countyCode": null,
    "regionNamePinyin": "chizhoushi",
    "regionNameInitial": "C"
}, {
    "cityCode": "430100",
    "cityName": "长沙市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130733981906059265",
    "countyCode": null,
    "regionNamePinyin": "changshashi",
    "regionNameInitial": "C"
}, {
    "cityCode": "430700",
    "cityName": "常德市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130734037300232194",
    "countyCode": null,
    "regionNamePinyin": "changdeshi",
    "regionNameInitial": "C"
}, {
    "cityCode": "431000",
    "cityName": "郴州市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130734067679576066",
    "countyCode": null,
    "regionNamePinyin": "chenzhoushi",
    "regionNameInitial": "C"
}, {
    "cityCode": "445100",
    "cityName": "潮州市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733989074124801",
    "countyCode": null,
    "regionNamePinyin": "chaozhoushi",
    "regionNameInitial": "C"
}, {
    "cityCode": "451400",
    "cityName": "崇左市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734074948304898",
    "countyCode": null,
    "regionNamePinyin": "chongzuoshi",
    "regionNameInitial": "C"
}, {
    "cityCode": "469023",
    "cityName": "澄迈县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733974373089282",
    "countyCode": null,
    "regionNamePinyin": "chengmaixian",
    "regionNameInitial": "C"
}, {
    "cityCode": "469026",
    "cityName": "昌江黎族自治县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733974175956994",
    "countyCode": null,
    "regionNamePinyin": "changjianglizuzizhixian",
    "regionNameInitial": "C"
}, {
    "cityCode": "500000",
    "cityName": "重庆市",
    "provinceCode": "500000",
    "provinceName": "重庆市",
    "id": "1130734043931426818",
    "countyCode": null,
    "regionNamePinyin": "chongqingshi",
    "regionNameInitial": "C"
}, {
    "cityCode": "510100",
    "cityName": "成都市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734068984004610",
    "countyCode": null,
    "regionNamePinyin": "chengdushi",
    "regionNameInitial": "C"
}, {
    "cityCode": "532300",
    "cityName": "楚雄彝族自治州",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130734092442746881",
    "countyCode": null,
    "regionNamePinyin": "chuxiongyizuzizhizhou",
    "regionNameInitial": "C"
}, {
    "cityCode": "540300",
    "cityName": "昌都市",
    "provinceCode": "540000",
    "provinceName": "西藏自治区",
    "id": "1130733996854558722",
    "countyCode": null,
    "regionNamePinyin": "changdushi",
    "regionNameInitial": "C"
}, {
    "cityCode": "652300",
    "cityName": "昌吉回族自治州",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734044984197121",
    "countyCode": null,
    "regionNamePinyin": "changjihuizuzizhizhou",
    "regionNameInitial": "C"
}]], ["D", [{
    "cityCode": "140200",
    "cityName": "大同市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130733986037448706",
    "countyCode": null,
    "regionNamePinyin": "datongshi",
    "regionNameInitial": "D"
}, {
    "cityCode": "210200",
    "cityName": "大连市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130734091339644929",
    "countyCode": null,
    "regionNamePinyin": "dalianshi",
    "regionNameInitial": "D"
}, {
    "cityCode": "210600",
    "cityName": "丹东市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130733992777695233",
    "countyCode": null,
    "regionNamePinyin": "dandongshi",
    "regionNameInitial": "D"
}, {
    "cityCode": "230600",
    "cityName": "大庆市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130734077712351234",
    "countyCode": null,
    "regionNamePinyin": "daqingshi",
    "regionNameInitial": "D"
}, {
    "cityCode": "232700",
    "cityName": "大兴安岭地区",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130734067641827329",
    "countyCode": null,
    "regionNamePinyin": "daxinganlingdiqu",
    "regionNameInitial": "D"
}, {
    "cityCode": "370500",
    "cityName": "东营市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130733992203075586",
    "countyCode": null,
    "regionNamePinyin": "dongyingshi",
    "regionNameInitial": "D"
}, {
    "cityCode": "371400",
    "cityName": "德州市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734089758392322",
    "countyCode": null,
    "regionNamePinyin": "dezhoushi",
    "regionNameInitial": "D"
}, {
    "cityCode": "441900",
    "cityName": "东莞市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734062591885313",
    "countyCode": null,
    "regionNamePinyin": "dongguanshi",
    "regionNameInitial": "D"
}, {
    "cityCode": "460400",
    "cityName": "儋州市",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733997571784705",
    "countyCode": null,
    "regionNamePinyin": "danzhoushi",
    "regionNameInitial": "D"
}, {
    "cityCode": "469007",
    "cityName": "东方市",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733975761403906",
    "countyCode": null,
    "regionNamePinyin": "dongfangshi",
    "regionNameInitial": "D"
}, {
    "cityCode": "469021",
    "cityName": "定安县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733974519889922",
    "countyCode": null,
    "regionNamePinyin": "dinganxian",
    "regionNameInitial": "D"
}, {
    "cityCode": "510600",
    "cityName": "德阳市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130733984032571393",
    "countyCode": null,
    "regionNamePinyin": "deyangshi",
    "regionNameInitial": "D"
}, {
    "cityCode": "511700",
    "cityName": "达州市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734035454738434",
    "countyCode": null,
    "regionNamePinyin": "dazhoushi",
    "regionNameInitial": "D"
}, {
    "cityCode": "532900",
    "cityName": "大理白族自治州",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130733977061638145",
    "countyCode": null,
    "regionNamePinyin": "dalibaizuzizhizhou",
    "regionNameInitial": "D"
}, {
    "cityCode": "533100",
    "cityName": "德宏傣族景颇族自治州",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130733992496676866",
    "countyCode": null,
    "regionNamePinyin": "dehongdaizujingpozuzizhizhou",
    "regionNameInitial": "D"
}, {
    "cityCode": "533400",
    "cityName": "迪庆藏族自治州",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130733974763159553",
    "countyCode": null,
    "regionNamePinyin": "diqingcangzuzizhizhou",
    "regionNameInitial": "D"
}, {
    "cityCode": "621100",
    "cityName": "定西市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130734058506633218",
    "countyCode": null,
    "regionNamePinyin": "dingxishi",
    "regionNameInitial": "D"
}]], ["E", [{
    "cityCode": "150600",
    "cityName": "鄂尔多斯市",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130733960104067074",
    "countyCode": null,
    "regionNamePinyin": "eerduosishi",
    "regionNameInitial": "E"
}, {
    "cityCode": "420700",
    "cityName": "鄂州市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130733984707854337",
    "countyCode": null,
    "regionNamePinyin": "ezhoushi",
    "regionNameInitial": "E"
}, {
    "cityCode": "422800",
    "cityName": "恩施土家族苗族自治州",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734057562914817",
    "countyCode": null,
    "regionNamePinyin": "enshitujiazumiaozuzizhizhou",
    "regionNameInitial": "E"
}]], ["F", [{
    "cityCode": "210400",
    "cityName": "抚顺市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130734057726492674",
    "countyCode": null,
    "regionNamePinyin": "fushunshi",
    "regionNameInitial": "F"
}, {
    "cityCode": "210900",
    "cityName": "阜新市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130733980349972482",
    "countyCode": null,
    "regionNamePinyin": "fuxinshi",
    "regionNameInitial": "F"
}, {
    "cityCode": "341200",
    "cityName": "阜阳市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734010590904321",
    "countyCode": null,
    "regionNamePinyin": "fuyangshi",
    "regionNameInitial": "F"
}, {
    "cityCode": "350100",
    "cityName": "福州市",
    "provinceCode": "350000",
    "provinceName": "福建省",
    "id": "1130734041070911490",
    "countyCode": null,
    "regionNamePinyin": "fuzhoushi",
    "regionNameInitial": "F"
}, {
    "cityCode": "361000",
    "cityName": "抚州市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130733988063297538",
    "countyCode": null,
    "regionNamePinyin": "fuzhoushi",
    "regionNameInitial": "F"
}, {
    "cityCode": "440600",
    "cityName": "佛山市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734060951912449",
    "countyCode": null,
    "regionNamePinyin": "foshanshi",
    "regionNameInitial": "F"
}, {
    "cityCode": "450600",
    "cityName": "防城港市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734093587791873",
    "countyCode": null,
    "regionNamePinyin": "fangchenggangshi",
    "regionNameInitial": "F"
}]], ["G", [{
    "cityCode": "360700",
    "cityName": "赣州市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130734080157630465",
    "countyCode": null,
    "regionNamePinyin": "ganzhoushi",
    "regionNameInitial": "G"
}, {
    "cityCode": "440100",
    "cityName": "广州市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734026353098753",
    "countyCode": null,
    "regionNamePinyin": "guangzhoushi",
    "regionNameInitial": "G"
}, {
    "cityCode": "450300",
    "cityName": "桂林市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734039720345601",
    "countyCode": null,
    "regionNamePinyin": "guilinshi",
    "regionNameInitial": "G"
}, {
    "cityCode": "450800",
    "cityName": "贵港市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734064215080961",
    "countyCode": null,
    "regionNamePinyin": "guigangshi",
    "regionNameInitial": "G"
}, {
    "cityCode": "510800",
    "cityName": "广元市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734104866275329",
    "countyCode": null,
    "regionNamePinyin": "guangyuanshi",
    "regionNameInitial": "G"
}, {
    "cityCode": "511600",
    "cityName": "广安市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734061400702977",
    "countyCode": null,
    "regionNamePinyin": "guanganshi",
    "regionNameInitial": "G"
}, {
    "cityCode": "513300",
    "cityName": "甘孜藏族自治州",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734057420308482",
    "countyCode": null,
    "regionNamePinyin": "ganzicangzuzizhizhou",
    "regionNameInitial": "G"
}, {
    "cityCode": "520100",
    "cityName": "贵阳市",
    "provinceCode": "520000",
    "provinceName": "贵州省",
    "id": "1130733973030912002",
    "countyCode": null,
    "regionNamePinyin": "guiyangshi",
    "regionNameInitial": "G"
}, {
    "cityCode": "623000",
    "cityName": "甘南藏族自治州",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130734041024774146",
    "countyCode": null,
    "regionNamePinyin": "gannancangzuzizhizhou",
    "regionNameInitial": "G"
}, {
    "cityCode": "632600",
    "cityName": "果洛藏族自治州",
    "provinceCode": "630000",
    "provinceName": "青海省",
    "id": "1130734066559696898",
    "countyCode": null,
    "regionNamePinyin": "guoluocangzuzizhizhou",
    "regionNameInitial": "G"
}, {
    "cityCode": "640400",
    "cityName": "固原市",
    "provinceCode": "640000",
    "provinceName": "宁夏回族自治区",
    "id": "1130734026093051905",
    "countyCode": null,
    "regionNamePinyin": "guyuanshi",
    "regionNameInitial": "G"
}, {
    "cityCode": "710600",
    "cityName": "高雄市",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734013124263938",
    "countyCode": null,
    "regionNamePinyin": "gaoxiongshi",
    "regionNameInitial": "G"
}]], ["H", [{
    "cityCode": "130400",
    "cityName": "邯郸市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130734074369490946",
    "countyCode": null,
    "regionNamePinyin": "handanshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "131100",
    "cityName": "衡水市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130734105155682306",
    "countyCode": null,
    "regionNamePinyin": "hengshuishi",
    "regionNameInitial": "H"
}, {
    "cityCode": "150100",
    "cityName": "呼和浩特市",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130734070766583810",
    "countyCode": null,
    "regionNamePinyin": "huhehaoteshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "150700",
    "cityName": "呼伦贝尔市",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130734013916987394",
    "countyCode": null,
    "regionNamePinyin": "hulunbeiershi",
    "regionNameInitial": "H"
}, {
    "cityCode": "211400",
    "cityName": "葫芦岛市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130733984221315074",
    "countyCode": null,
    "regionNamePinyin": "huludaoshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "230100",
    "cityName": "哈尔滨市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130734071957766146",
    "countyCode": null,
    "regionNamePinyin": "haerbinshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "230400",
    "cityName": "鹤岗市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130733962775838721",
    "countyCode": null,
    "regionNamePinyin": "hegangshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "231100",
    "cityName": "黑河市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130734089619980290",
    "countyCode": null,
    "regionNamePinyin": "heiheshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "320800",
    "cityName": "淮安市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734054580764673",
    "countyCode": null,
    "regionNamePinyin": "huaianshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "330100",
    "cityName": "杭州市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130734105407340545",
    "countyCode": null,
    "regionNamePinyin": "hangzhoushi",
    "regionNameInitial": "H"
}, {
    "cityCode": "330500",
    "cityName": "湖州市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130734013451419650",
    "countyCode": null,
    "regionNamePinyin": "huzhoushi",
    "regionNameInitial": "H"
}, {
    "cityCode": "340100",
    "cityName": "合肥市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130733979347533825",
    "countyCode": null,
    "regionNamePinyin": "hefeishi",
    "regionNameInitial": "H"
}, {
    "cityCode": "340400",
    "cityName": "淮南市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734046921965569",
    "countyCode": null,
    "regionNamePinyin": "huainanshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "340600",
    "cityName": "淮北市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130733993566224385",
    "countyCode": null,
    "regionNamePinyin": "huaibeishi",
    "regionNameInitial": "H"
}, {
    "cityCode": "341000",
    "cityName": "黄山市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734077175480322",
    "countyCode": null,
    "regionNamePinyin": "huangshanshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "371700",
    "cityName": "菏泽市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734068069646338",
    "countyCode": null,
    "regionNamePinyin": "hezeshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "410600",
    "cityName": "鹤壁市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734079348129794",
    "countyCode": null,
    "regionNamePinyin": "hebishi",
    "regionNameInitial": "H"
}, {
    "cityCode": "420200",
    "cityName": "黄石市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734045827252225",
    "countyCode": null,
    "regionNamePinyin": "huangshishi",
    "regionNameInitial": "H"
}, {
    "cityCode": "421100",
    "cityName": "黄冈市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130733959130988545",
    "countyCode": null,
    "regionNamePinyin": "huanggangshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "430400",
    "cityName": "衡阳市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130734055742586881",
    "countyCode": null,
    "regionNamePinyin": "hengyangshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "431200",
    "cityName": "怀化市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130734015460491266",
    "countyCode": null,
    "regionNamePinyin": "huaihuashi",
    "regionNameInitial": "H"
}, {
    "cityCode": "441300",
    "cityName": "惠州市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733993343926274",
    "countyCode": null,
    "regionNamePinyin": "huizhoushi",
    "regionNameInitial": "H"
}, {
    "cityCode": "441600",
    "cityName": "河源市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733986368798721",
    "countyCode": null,
    "regionNamePinyin": "heyuanshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "451100",
    "cityName": "贺州市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734081705328641",
    "countyCode": null,
    "regionNamePinyin": "hezhoushi",
    "regionNameInitial": "H"
}, {
    "cityCode": "451200",
    "cityName": "河池市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734102685237250",
    "countyCode": null,
    "regionNamePinyin": "hechishi",
    "regionNameInitial": "H"
}, {
    "cityCode": "460100",
    "cityName": "海口市",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130734103184359426",
    "countyCode": null,
    "regionNamePinyin": "haikoushi",
    "regionNameInitial": "H"
}, {
    "cityCode": "532500",
    "cityName": "红河哈尼族彝族自治州",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130734060540870658",
    "countyCode": null,
    "regionNamePinyin": "honghehanizuyizuzizhizhou",
    "regionNameInitial": "H"
}, {
    "cityCode": "610700",
    "cityName": "汉中市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130733993020964865",
    "countyCode": null,
    "regionNamePinyin": "hanzhongshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "630200",
    "cityName": "海东市",
    "provinceCode": "630000",
    "provinceName": "青海省",
    "id": "1130734012742582274",
    "countyCode": null,
    "regionNamePinyin": "haidongshi",
    "regionNameInitial": "H"
}, {
    "cityCode": "632200",
    "cityName": "海北藏族自治州",
    "provinceCode": "630000",
    "provinceName": "青海省",
    "id": "1130733977149718529",
    "countyCode": null,
    "regionNamePinyin": "haibeicangzuzizhizhou",
    "regionNameInitial": "H"
}, {
    "cityCode": "632300",
    "cityName": "黄南藏族自治州",
    "provinceCode": "630000",
    "provinceName": "青海省",
    "id": "1130734104413290498",
    "countyCode": null,
    "regionNamePinyin": "huangnancangzuzizhizhou",
    "regionNameInitial": "H"
}, {
    "cityCode": "632500",
    "cityName": "海南藏族自治州",
    "provinceCode": "630000",
    "provinceName": "青海省",
    "id": "1130734078588960770",
    "countyCode": null,
    "regionNamePinyin": "hainancangzuzizhizhou",
    "regionNameInitial": "H"
}, {
    "cityCode": "632800",
    "cityName": "海西蒙古族藏族自治州",
    "provinceCode": "630000",
    "provinceName": "青海省",
    "id": "1130734000566517762",
    "countyCode": null,
    "regionNamePinyin": "haiximengguzucangzuzizhizhou",
    "regionNameInitial": "H"
}, {
    "cityCode": "650500",
    "cityName": "哈密市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734046993268738",
    "countyCode": null,
    "regionNamePinyin": "hamishi",
    "regionNameInitial": "H"
}, {
    "cityCode": "653200",
    "cityName": "和田地区",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130733962931027970",
    "countyCode": null,
    "regionNamePinyin": "hetiandiqu",
    "regionNameInitial": "H"
}, {
    "cityCode": "719010",
    "cityName": "花莲县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734026629922817",
    "countyCode": null,
    "regionNamePinyin": "hualianxian",
    "regionNameInitial": "H"
}]], ["J", [{
    "cityCode": "140500",
    "cityName": "晋城市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130734026655088642",
    "countyCode": null,
    "regionNamePinyin": "jinchengshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "140700",
    "cityName": "晋中市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130734066396119041",
    "countyCode": null,
    "regionNamePinyin": "jinzhongshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "210700",
    "cityName": "锦州市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130734014445469698",
    "countyCode": null,
    "regionNamePinyin": "jinzhoushi",
    "regionNameInitial": "J"
}, {
    "cityCode": "220200",
    "cityName": "吉林市",
    "provinceCode": "220000",
    "provinceName": "吉林省",
    "id": "1130733969197318145",
    "countyCode": null,
    "regionNamePinyin": "jilinshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "230300",
    "cityName": "鸡西市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130734015074615298",
    "countyCode": null,
    "regionNamePinyin": "jixishi",
    "regionNameInitial": "J"
}, {
    "cityCode": "230800",
    "cityName": "佳木斯市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130734106053263362",
    "countyCode": null,
    "regionNamePinyin": "jiamusishi",
    "regionNameInitial": "J"
}, {
    "cityCode": "330400",
    "cityName": "嘉兴市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130733991095779330",
    "countyCode": null,
    "regionNamePinyin": "jiaxingshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "330700",
    "cityName": "金华市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130733981776035841",
    "countyCode": null,
    "regionNamePinyin": "jinhuashi",
    "regionNameInitial": "J"
}, {
    "cityCode": "360200",
    "cityName": "景德镇市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130733995470438402",
    "countyCode": null,
    "regionNamePinyin": "jingdezhenshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "360400",
    "cityName": "九江市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130734026386653186",
    "countyCode": null,
    "regionNamePinyin": "jiujiangshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "360800",
    "cityName": "吉安市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130734097371054081",
    "countyCode": null,
    "regionNamePinyin": "jianshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "370100",
    "cityName": "济南市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734101540192258",
    "countyCode": null,
    "regionNamePinyin": "jinanshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "370800",
    "cityName": "济宁市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130733979175567361",
    "countyCode": null,
    "regionNamePinyin": "jiningshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "410800",
    "cityName": "焦作市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734055335739394",
    "countyCode": null,
    "regionNamePinyin": "jiaozuoshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "419001",
    "cityName": "济源市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734078668652545",
    "countyCode": null,
    "regionNamePinyin": "jiyuanshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "420800",
    "cityName": "荆门市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734090429480961",
    "countyCode": null,
    "regionNamePinyin": "jingmenshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "421000",
    "cityName": "荆州市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734011207467010",
    "countyCode": null,
    "regionNamePinyin": "jingzhoushi",
    "regionNameInitial": "J"
}, {
    "cityCode": "440700",
    "cityName": "江门市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734076105932801",
    "countyCode": null,
    "regionNamePinyin": "jiangmenshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "445200",
    "cityName": "揭阳市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733979624357889",
    "countyCode": null,
    "regionNamePinyin": "jieyangshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "620200",
    "cityName": "嘉峪关市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130733973999796225",
    "countyCode": null,
    "regionNamePinyin": "jiayuguanshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "620300",
    "cityName": "金昌市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130733963396595714",
    "countyCode": null,
    "regionNamePinyin": "jinchangshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "620900",
    "cityName": "酒泉市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130733990932201473",
    "countyCode": null,
    "regionNamePinyin": "jiuquanshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "710700",
    "cityName": "基隆市",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734045500096513",
    "countyCode": null,
    "regionNamePinyin": "jilongshi",
    "regionNameInitial": "J"
}, {
    "cityCode": "710900",
    "cityName": "嘉义市",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734075279654914",
    "countyCode": null,
    "regionNamePinyin": "jiayishi",
    "regionNameInitial": "J"
}, {
    "cityCode": "719006",
    "cityName": "嘉义县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734022590808066",
    "countyCode": null,
    "regionNamePinyin": "jiayixian",
    "regionNameInitial": "J"
}, {
    "cityCode": "719012",
    "cityName": "金门县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734026516676610",
    "countyCode": null,
    "regionNamePinyin": "jinmenxian",
    "regionNameInitial": "J"
}]], ["K", [{
    "cityCode": "410200",
    "cityName": "开封市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130733991951417346",
    "countyCode": null,
    "regionNamePinyin": "kaifengshi",
    "regionNameInitial": "K"
}, {
    "cityCode": "530100",
    "cityName": "昆明市",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130733994417668098",
    "countyCode": null,
    "regionNamePinyin": "kunmingshi",
    "regionNameInitial": "K"
}, {
    "cityCode": "650200",
    "cityName": "克拉玛依市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734100944601089",
    "countyCode": null,
    "regionNamePinyin": "kelamayishi",
    "regionNameInitial": "K"
}, {
    "cityCode": "653000",
    "cityName": "克孜勒苏柯尔克孜自治州",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130733988390453250",
    "countyCode": null,
    "regionNamePinyin": "kezilesukeerkezizizhizhou",
    "regionNameInitial": "K"
}, {
    "cityCode": "653100",
    "cityName": "喀什地区",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130733976071782401",
    "countyCode": null,
    "regionNamePinyin": "kashendiqu",
    "regionNameInitial": "K"
}, {
    "cityCode": "659008",
    "cityName": "可克达拉市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734023454834690",
    "countyCode": null,
    "regionNamePinyin": "kekedalashi",
    "regionNameInitial": "K"
}, {
    "cityCode": "659009",
    "cityName": "昆玉市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734023274479617",
    "countyCode": null,
    "regionNamePinyin": "kunyushi",
    "regionNameInitial": "K"
}]], ["L", [{
    "cityCode": "131000",
    "cityName": "廊坊市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130734062512193537",
    "countyCode": null,
    "regionNamePinyin": "langfangshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "141000",
    "cityName": "临汾市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130733997940883458",
    "countyCode": null,
    "regionNamePinyin": "linfenshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "141100",
    "cityName": "吕梁市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130734073706790914",
    "countyCode": null,
    "regionNamePinyin": "lvliangshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "211000",
    "cityName": "辽阳市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130734075317403649",
    "countyCode": null,
    "regionNamePinyin": "liaoyangshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "220400",
    "cityName": "辽源市",
    "provinceCode": "220000",
    "provinceName": "吉林省",
    "id": "1130734080837107713",
    "countyCode": null,
    "regionNamePinyin": "liaoyuanshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "320700",
    "cityName": "连云港市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734097152950274",
    "countyCode": null,
    "regionNamePinyin": "lianyungangshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "331100",
    "cityName": "丽水市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130733976981946370",
    "countyCode": null,
    "regionNamePinyin": "lishuishi",
    "regionNameInitial": "L"
}, {
    "cityCode": "341500",
    "cityName": "六安市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734078828036097",
    "countyCode": null,
    "regionNamePinyin": "luanshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "350800",
    "cityName": "龙岩市",
    "provinceCode": "350000",
    "provinceName": "福建省",
    "id": "1130734068904312833",
    "countyCode": null,
    "regionNamePinyin": "longyanshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "371200",
    "cityName": "莱芜市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130733984808517633",
    "countyCode": null,
    "regionNamePinyin": "laiwushi",
    "regionNameInitial": "L"
}, {
    "cityCode": "371300",
    "cityName": "临沂市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734090563698689",
    "countyCode": null,
    "regionNamePinyin": "linyishi",
    "regionNameInitial": "L"
}, {
    "cityCode": "371500",
    "cityName": "聊城市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734099560480769",
    "countyCode": null,
    "regionNamePinyin": "liaochengshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "410300",
    "cityName": "洛阳市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734013220732929",
    "countyCode": null,
    "regionNamePinyin": "luoyangshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "411100",
    "cityName": "漯河市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734104757223425",
    "countyCode": null,
    "regionNamePinyin": "luoheshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "431300",
    "cityName": "娄底市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130733963325292545",
    "countyCode": null,
    "regionNamePinyin": "loudishi",
    "regionNameInitial": "L"
}, {
    "cityCode": "450200",
    "cityName": "柳州市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130733994996482049",
    "countyCode": null,
    "regionNamePinyin": "liuzhoushi",
    "regionNameInitial": "L"
}, {
    "cityCode": "451300",
    "cityName": "来宾市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734058376609793",
    "countyCode": null,
    "regionNamePinyin": "laibinshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "469024",
    "cityName": "临高县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733974280814594",
    "countyCode": null,
    "regionNamePinyin": "lingaoxian",
    "regionNameInitial": "L"
}, {
    "cityCode": "469027",
    "cityName": "乐东黎族自治县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733974154985474",
    "countyCode": null,
    "regionNamePinyin": "ledonglizuzizhixian",
    "regionNameInitial": "L"
}, {
    "cityCode": "469028",
    "cityName": "陵水黎族自治县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733974125625346",
    "countyCode": null,
    "regionNamePinyin": "lingshuilizuzizhixian",
    "regionNameInitial": "L"
}, {
    "cityCode": "510500",
    "cityName": "泸州市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130733995105533954",
    "countyCode": null,
    "regionNamePinyin": "luzhoushi",
    "regionNameInitial": "L"
}, {
    "cityCode": "511100",
    "cityName": "乐山市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130733966215168004",
    "countyCode": null,
    "regionNamePinyin": "leshanshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "513400",
    "cityName": "凉山彝族自治州",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734016353878018",
    "countyCode": null,
    "regionNamePinyin": "liangshanyizuzizhizhou",
    "regionNameInitial": "L"
}, {
    "cityCode": "520200",
    "cityName": "六盘水市",
    "provinceCode": "520000",
    "provinceName": "贵州省",
    "id": "1130734103649927169",
    "countyCode": null,
    "regionNamePinyin": "liupanshuishi",
    "regionNameInitial": "L"
}, {
    "cityCode": "530700",
    "cityName": "丽江市",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130734046120853506",
    "countyCode": null,
    "regionNamePinyin": "lijiangshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "530900",
    "cityName": "临沧市",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130733990009454593",
    "countyCode": null,
    "regionNamePinyin": "lincangshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "540100",
    "cityName": "拉萨市",
    "provinceCode": "540000",
    "provinceName": "西藏自治区",
    "id": "1130734063657238529",
    "countyCode": null,
    "regionNamePinyin": "lasashi",
    "regionNameInitial": "L"
}, {
    "cityCode": "540400",
    "cityName": "林芝市",
    "provinceCode": "540000",
    "provinceName": "西藏自治区",
    "id": "1130733987971022850",
    "countyCode": null,
    "regionNamePinyin": "linzhishi",
    "regionNameInitial": "L"
}, {
    "cityCode": "620100",
    "cityName": "兰州市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130733985278279681",
    "countyCode": null,
    "regionNamePinyin": "lanzhoushi",
    "regionNameInitial": "L"
}, {
    "cityCode": "621200",
    "cityName": "陇南市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130734028999704578",
    "countyCode": null,
    "regionNamePinyin": "longnanshi",
    "regionNameInitial": "L"
}, {
    "cityCode": "622900",
    "cityName": "临夏回族自治州",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130733967825780738",
    "countyCode": null,
    "regionNamePinyin": "linxiahuizuzizhizhou",
    "regionNameInitial": "L"
}, {
    "cityCode": "719013",
    "cityName": "连江县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734026478927873",
    "countyCode": null,
    "regionNamePinyin": "lianjiangxian",
    "regionNameInitial": "L"
}]], ["M", [{
    "cityCode": "231000",
    "cityName": "牡丹江市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130733984003211266",
    "countyCode": null,
    "regionNamePinyin": "mudanjiangshi",
    "regionNameInitial": "M"
}, {
    "cityCode": "340500",
    "cityName": "马鞍山市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734068853981185",
    "countyCode": null,
    "regionNamePinyin": "maanshanshi",
    "regionNameInitial": "M"
}, {
    "cityCode": "440900",
    "cityName": "茂名市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734042798964738",
    "countyCode": null,
    "regionNamePinyin": "maomingshi",
    "regionNameInitial": "M"
}, {
    "cityCode": "441400",
    "cityName": "梅州市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734028819349506",
    "countyCode": null,
    "regionNamePinyin": "meizhoushi",
    "regionNameInitial": "M"
}, {
    "cityCode": "510700",
    "cityName": "绵阳市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130733978215071745",
    "countyCode": null,
    "regionNamePinyin": "mianyangshi",
    "regionNameInitial": "M"
}, {
    "cityCode": "511400",
    "cityName": "眉山市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734092413386753",
    "countyCode": null,
    "regionNamePinyin": "meishanshi",
    "regionNameInitial": "M"
}, {
    "cityCode": "719003",
    "cityName": "苗栗县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734022590808070",
    "countyCode": null,
    "regionNamePinyin": "miaolixian",
    "regionNameInitial": "M"
}]], ["N", [{
    "cityCode": "320100",
    "cityName": "南京市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734076592472066",
    "countyCode": null,
    "regionNamePinyin": "nanjingshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "320600",
    "cityName": "南通市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734078391828482",
    "countyCode": null,
    "regionNamePinyin": "nantongshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "330200",
    "cityName": "宁波市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130734043621048322",
    "countyCode": null,
    "regionNamePinyin": "ningboshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "350700",
    "cityName": "南平市",
    "provinceCode": "350000",
    "provinceName": "福建省",
    "id": "1130734055704838146",
    "countyCode": null,
    "regionNamePinyin": "nanpingshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "350900",
    "cityName": "宁德市",
    "provinceCode": "350000",
    "provinceName": "福建省",
    "id": "1130733992253407234",
    "countyCode": null,
    "regionNamePinyin": "ningdeshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "360100",
    "cityName": "南昌市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130734074646315009",
    "countyCode": null,
    "regionNamePinyin": "nanchangshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "411300",
    "cityName": "南阳市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734043755266049",
    "countyCode": null,
    "regionNamePinyin": "nanyangshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "450100",
    "cityName": "南宁市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734074293993474",
    "countyCode": null,
    "regionNamePinyin": "nanningshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "511000",
    "cityName": "内江市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130733983596363778",
    "countyCode": null,
    "regionNamePinyin": "neijiangshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "511300",
    "cityName": "南充市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734079155191810",
    "countyCode": null,
    "regionNamePinyin": "nanchongshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "533300",
    "cityName": "怒江傈僳族自治州",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130733985940979713",
    "countyCode": null,
    "regionNamePinyin": "nujianglisuzuzizhizhou",
    "regionNameInitial": "N"
}, {
    "cityCode": "540600",
    "cityName": "那曲市",
    "provinceCode": "540000",
    "provinceName": "西藏自治区",
    "id": "1130734096628662274",
    "countyCode": null,
    "regionNamePinyin": "naqushi",
    "regionNameInitial": "N"
}, {
    "cityCode": "719005",
    "cityName": "南投县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734022590808067",
    "countyCode": null,
    "regionNamePinyin": "nantouxian",
    "regionNameInitial": "N"
}]], ["P", [{
    "cityCode": "211100",
    "cityName": "盘锦市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130733995973754882",
    "countyCode": null,
    "regionNamePinyin": "panjinshi",
    "regionNameInitial": "P"
}, {
    "cityCode": "350300",
    "cityName": "莆田市",
    "provinceCode": "350000",
    "provinceName": "福建省",
    "id": "1130733985974534146",
    "countyCode": null,
    "regionNamePinyin": "putianshi",
    "regionNameInitial": "P"
}, {
    "cityCode": "360300",
    "cityName": "萍乡市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130734028345393154",
    "countyCode": null,
    "regionNamePinyin": "pingxiangshi",
    "regionNameInitial": "P"
}, {
    "cityCode": "410400",
    "cityName": "平顶山市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130733961756622851",
    "countyCode": null,
    "regionNamePinyin": "pingdingshanshi",
    "regionNameInitial": "P"
}, {
    "cityCode": "410900",
    "cityName": "濮阳市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734073497075714",
    "countyCode": null,
    "regionNamePinyin": "puyangshi",
    "regionNameInitial": "P"
}, {
    "cityCode": "510400",
    "cityName": "攀枝花市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734036020969474",
    "countyCode": null,
    "regionNamePinyin": "panzhihuashi",
    "regionNameInitial": "P"
}, {
    "cityCode": "530800",
    "cityName": "普洱市",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130734013841489921",
    "countyCode": null,
    "regionNamePinyin": "puershi",
    "regionNameInitial": "P"
}, {
    "cityCode": "620800",
    "cityName": "平凉市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130734010704150529",
    "countyCode": null,
    "regionNamePinyin": "pingliangshi",
    "regionNameInitial": "P"
}, {
    "cityCode": "719008",
    "cityName": "屏东县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734022871826435",
    "countyCode": null,
    "regionNamePinyin": "pingdongxian",
    "regionNameInitial": "P"
}, {
    "cityCode": "719011",
    "cityName": "澎湖县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734026617339905",
    "countyCode": null,
    "regionNamePinyin": "penghuxian",
    "regionNameInitial": "P"
}]], ["Q", [{
    "cityCode": "130300",
    "cityName": "秦皇岛市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130733996158304258",
    "countyCode": null,
    "regionNamePinyin": "qinhuangdaoshi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "230200",
    "cityName": "齐齐哈尔市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130733993121628161",
    "countyCode": null,
    "regionNamePinyin": "qiqihaershi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "230900",
    "cityName": "七台河市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130734064345104386",
    "countyCode": null,
    "regionNamePinyin": "qitaiheshi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "330800",
    "cityName": "衢州市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130734081369784321",
    "countyCode": null,
    "regionNamePinyin": "quzhoushi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "350500",
    "cityName": "泉州市",
    "provinceCode": "350000",
    "provinceName": "福建省",
    "id": "1130734102353887234",
    "countyCode": null,
    "regionNamePinyin": "quanzhoushi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "370200",
    "cityName": "青岛市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734099749224449",
    "countyCode": null,
    "regionNamePinyin": "qingdaoshi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "429005",
    "cityName": "潜江市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130733964298371075",
    "countyCode": null,
    "regionNamePinyin": "qianjiangshi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "441800",
    "cityName": "清远市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734104547508226",
    "countyCode": null,
    "regionNamePinyin": "qingyuanshi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "450700",
    "cityName": "钦州市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734105910657025",
    "countyCode": null,
    "regionNamePinyin": "qinzhoushi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "469002",
    "cityName": "琼海市",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733975316807683",
    "countyCode": null,
    "regionNamePinyin": "qionghaishi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "469030",
    "cityName": "琼中黎族苗族自治县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733975081926658",
    "countyCode": null,
    "regionNamePinyin": "qiongzhonglizumiaozuzizhixian",
    "regionNameInitial": "Q"
}, {
    "cityCode": "522300",
    "cityName": "黔西南布依族苗族自治州",
    "provinceCode": "520000",
    "provinceName": "贵州省",
    "id": "1130734015682789377",
    "countyCode": null,
    "regionNamePinyin": "qianxinanbuyizumiaozuzizhizhou",
    "regionNameInitial": "Q"
}, {
    "cityCode": "522600",
    "cityName": "黔东南苗族侗族自治州",
    "provinceCode": "520000",
    "provinceName": "贵州省",
    "id": "1130733984112263169",
    "countyCode": null,
    "regionNamePinyin": "qiandongnanmiaozudongzuzizhizhou",
    "regionNameInitial": "Q"
}, {
    "cityCode": "522700",
    "cityName": "黔南布依族苗族自治州",
    "provinceCode": "520000",
    "provinceName": "贵州省",
    "id": "1130733972091387906",
    "countyCode": null,
    "regionNamePinyin": "qiannanbuyizumiaozuzizhizhou",
    "regionNameInitial": "Q"
}, {
    "cityCode": "530300",
    "cityName": "曲靖市",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130733977728532481",
    "countyCode": null,
    "regionNamePinyin": "qujingshi",
    "regionNameInitial": "Q"
}, {
    "cityCode": "621000",
    "cityName": "庆阳市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130734077263560705",
    "countyCode": null,
    "regionNamePinyin": "qingyangshi",
    "regionNameInitial": "Q"
}]], ["R", [{
    "cityCode": "371100",
    "cityName": "日照市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130733973165129729",
    "countyCode": null,
    "regionNamePinyin": "rizhaoshi",
    "regionNameInitial": "R"
}, {
    "cityCode": "540200",
    "cityName": "日喀则市",
    "provinceCode": "540000",
    "provinceName": "西藏自治区",
    "id": "1130734042618609666",
    "countyCode": null,
    "regionNamePinyin": "rikazeshi",
    "regionNameInitial": "R"
}]], ["S", [{
    "cityCode": "130100",
    "cityName": "石家庄市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130733971856506881",
    "countyCode": null,
    "regionNamePinyin": "shijiazhuangshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "140600",
    "cityName": "朔州市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130733993771745282",
    "countyCode": null,
    "regionNamePinyin": "shuozhoushi",
    "regionNameInitial": "S"
}, {
    "cityCode": "210100",
    "cityName": "沈阳市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130733985588658177",
    "countyCode": null,
    "regionNamePinyin": "shenyangshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "220300",
    "cityName": "四平市",
    "provinceCode": "220000",
    "provinceName": "吉林省",
    "id": "1130733982963023873",
    "countyCode": null,
    "regionNamePinyin": "sipingshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "220700",
    "cityName": "松原市",
    "provinceCode": "220000",
    "provinceName": "吉林省",
    "id": "1130734066920407042",
    "countyCode": null,
    "regionNamePinyin": "songyuanshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "230500",
    "cityName": "双鸭山市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130733980605825025",
    "countyCode": null,
    "regionNamePinyin": "shuangyashanshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "231200",
    "cityName": "绥化市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130734099338182657",
    "countyCode": null,
    "regionNamePinyin": "suihuashi",
    "regionNameInitial": "S"
}, {
    "cityCode": "310000",
    "cityName": "上海市",
    "provinceCode": "310000",
    "provinceName": "上海市",
    "id": "1130733995780816897",
    "countyCode": null,
    "regionNamePinyin": "shanghaishi",
    "regionNameInitial": "S"
}, {
    "cityCode": "320500",
    "cityName": "苏州市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130733980056371202",
    "countyCode": null,
    "regionNamePinyin": "suzhoushi",
    "regionNameInitial": "S"
}, {
    "cityCode": "321300",
    "cityName": "宿迁市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734063309111297",
    "countyCode": null,
    "regionNamePinyin": "suqianshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "330600",
    "cityName": "绍兴市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130733963576950785",
    "countyCode": null,
    "regionNamePinyin": "shaoxingshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "341300",
    "cityName": "宿州市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130733961303638018",
    "countyCode": null,
    "regionNamePinyin": "suzhoushi",
    "regionNameInitial": "S"
}, {
    "cityCode": "350400",
    "cityName": "三明市",
    "provinceCode": "350000",
    "provinceName": "福建省",
    "id": "1130734091691966465",
    "countyCode": null,
    "regionNamePinyin": "sanmingshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "361100",
    "cityName": "上饶市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130734093248053250",
    "countyCode": null,
    "regionNamePinyin": "shangraoshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "411200",
    "cityName": "三门峡市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734095810772993",
    "countyCode": null,
    "regionNamePinyin": "sanmenxiashi",
    "regionNameInitial": "S"
}, {
    "cityCode": "411400",
    "cityName": "商丘市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734067465666561",
    "countyCode": null,
    "regionNamePinyin": "shangqiushi",
    "regionNameInitial": "S"
}, {
    "cityCode": "420300",
    "cityName": "十堰市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734068631683074",
    "countyCode": null,
    "regionNamePinyin": "shiyanshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "421300",
    "cityName": "随州市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734078337302529",
    "countyCode": null,
    "regionNamePinyin": "suizhoushi",
    "regionNameInitial": "S"
}, {
    "cityCode": "429021",
    "cityName": "神农架林区",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130733961756622850",
    "countyCode": null,
    "regionNamePinyin": "shennongjialinqu",
    "regionNameInitial": "S"
}, {
    "cityCode": "430500",
    "cityName": "邵阳市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130734073778094082",
    "countyCode": null,
    "regionNamePinyin": "shaoyangshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "440200",
    "cityName": "韶关市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733967444099076",
    "countyCode": null,
    "regionNamePinyin": "shaoguanshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "440300",
    "cityName": "深圳市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733985072758785",
    "countyCode": null,
    "regionNamePinyin": "shenzhenshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "440500",
    "cityName": "汕头市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734103838670849",
    "countyCode": null,
    "regionNamePinyin": "shantoushi",
    "regionNameInitial": "S"
}, {
    "cityCode": "441500",
    "cityName": "汕尾市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733969885184002",
    "countyCode": null,
    "regionNamePinyin": "shanweishi",
    "regionNameInitial": "S"
}, {
    "cityCode": "460200",
    "cityName": "三亚市",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130734061958545410",
    "countyCode": null,
    "regionNamePinyin": "sanyashi",
    "regionNameInitial": "S"
}, {
    "cityCode": "460300",
    "cityName": "三沙市",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130734075485175809",
    "countyCode": null,
    "regionNamePinyin": "sanshashi",
    "regionNameInitial": "S"
}, {
    "cityCode": "510900",
    "cityName": "遂宁市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734093944307714",
    "countyCode": null,
    "regionNamePinyin": "suiningshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "540500",
    "cityName": "山南市",
    "provinceCode": "540000",
    "provinceName": "西藏自治区",
    "id": "1130733961643376641",
    "countyCode": null,
    "regionNamePinyin": "shannanshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "611000",
    "cityName": "商洛市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130734041771360257",
    "countyCode": null,
    "regionNamePinyin": "shangluoshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "640200",
    "cityName": "石嘴山市",
    "provinceCode": "640000",
    "provinceName": "宁夏回族自治区",
    "id": "1130734066173820930",
    "countyCode": null,
    "regionNamePinyin": "shizuishanshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "659001",
    "cityName": "石河子市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734024004288513",
    "countyCode": null,
    "regionNamePinyin": "shihezishi",
    "regionNameInitial": "S"
}, {
    "cityCode": "659007",
    "cityName": "双河市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734023706492929",
    "countyCode": null,
    "regionNamePinyin": "shuangheshi",
    "regionNameInitial": "S"
}]], ["T", [{
    "cityCode": "120000",
    "cityName": "天津市",
    "provinceCode": "120000",
    "provinceName": "天津市",
    "id": "1130734042702495745",
    "countyCode": null,
    "regionNamePinyin": "tianjinshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "130200",
    "cityName": "唐山市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130734027712053249",
    "countyCode": null,
    "regionNamePinyin": "tangshanshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "140100",
    "cityName": "太原市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130734092908314625",
    "countyCode": null,
    "regionNamePinyin": "taiyuanshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "150500",
    "cityName": "通辽市",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130733979989262338",
    "countyCode": null,
    "regionNamePinyin": "tongliaoshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "211200",
    "cityName": "铁岭市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130734036452982787",
    "countyCode": null,
    "regionNamePinyin": "tielingshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "220500",
    "cityName": "通化市",
    "provinceCode": "220000",
    "provinceName": "吉林省",
    "id": "1130734097979228162",
    "countyCode": null,
    "regionNamePinyin": "tonghuashi",
    "regionNameInitial": "T"
}, {
    "cityCode": "321200",
    "cityName": "泰州市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734104283267074",
    "countyCode": null,
    "regionNamePinyin": "taizhoushi",
    "regionNameInitial": "T"
}, {
    "cityCode": "331000",
    "cityName": "台州市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130734041578422274",
    "countyCode": null,
    "regionNamePinyin": "taizhoushi",
    "regionNameInitial": "T"
}, {
    "cityCode": "340700",
    "cityName": "铜陵市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734024885092353",
    "countyCode": null,
    "regionNamePinyin": "tonglingshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "370900",
    "cityName": "泰安市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734077288726530",
    "countyCode": null,
    "regionNamePinyin": "taianshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "429006",
    "cityName": "天门市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130733964298371074",
    "countyCode": null,
    "regionNamePinyin": "tianmenshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "469022",
    "cityName": "屯昌县",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733974461169665",
    "countyCode": null,
    "regionNamePinyin": "tunchangxian",
    "regionNameInitial": "T"
}, {
    "cityCode": "520600",
    "cityName": "铜仁市",
    "provinceCode": "520000",
    "provinceName": "贵州省",
    "id": "1130734042878656514",
    "countyCode": null,
    "regionNamePinyin": "tongrenshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "610200",
    "cityName": "铜川市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130734091238981633",
    "countyCode": null,
    "regionNamePinyin": "tongchuanshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "620500",
    "cityName": "天水市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130734081294286849",
    "countyCode": null,
    "regionNamePinyin": "tianshuishi",
    "regionNameInitial": "T"
}, {
    "cityCode": "650400",
    "cityName": "吐鲁番市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734069021753345",
    "countyCode": null,
    "regionNamePinyin": "tulufanshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "654200",
    "cityName": "塔城地区",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130733997110411266",
    "countyCode": null,
    "regionNamePinyin": "tachengdiqu",
    "regionNameInitial": "T"
}, {
    "cityCode": "659003",
    "cityName": "图木舒克市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734022871826440",
    "countyCode": null,
    "regionNamePinyin": "tumushukeshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "659006",
    "cityName": "铁门关市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734023878459394",
    "countyCode": null,
    "regionNamePinyin": "tiemenguanshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "710100",
    "cityName": "台北市",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734080061161473",
    "countyCode": null,
    "regionNamePinyin": "taibeishi",
    "regionNameInitial": "T"
}, {
    "cityCode": "710300",
    "cityName": "桃园市",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130733967838363650",
    "countyCode": null,
    "regionNamePinyin": "taoyuanshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "710400",
    "cityName": "台中市",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130733980127674370",
    "countyCode": null,
    "regionNamePinyin": "taizhongshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "710500",
    "cityName": "台南市",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130733990248529921",
    "countyCode": null,
    "regionNamePinyin": "tainanshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "719009",
    "cityName": "台东县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734022871826433",
    "countyCode": null,
    "regionNamePinyin": "taidongxian",
    "regionNameInitial": "T"
}]], ["W", [{
    "cityCode": "150300",
    "cityName": "乌海市",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130734101414363137",
    "countyCode": null,
    "regionNamePinyin": "wuhaishi",
    "regionNameInitial": "W"
}, {
    "cityCode": "150900",
    "cityName": "乌兰察布市",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130734076261122049",
    "countyCode": null,
    "regionNamePinyin": "wulanchabushi",
    "regionNameInitial": "W"
}, {
    "cityCode": "320200",
    "cityName": "无锡市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130733998410645505",
    "countyCode": null,
    "regionNamePinyin": "wuxishi",
    "regionNameInitial": "W"
}, {
    "cityCode": "330300",
    "cityName": "温州市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130734066148655106",
    "countyCode": null,
    "regionNamePinyin": "wenzhoushi",
    "regionNameInitial": "W"
}, {
    "cityCode": "340200",
    "cityName": "芜湖市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734077959815170",
    "countyCode": null,
    "regionNamePinyin": "wuhushi",
    "regionNameInitial": "W"
}, {
    "cityCode": "370700",
    "cityName": "潍坊市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130733962075389954",
    "countyCode": null,
    "regionNamePinyin": "weifangshi",
    "regionNameInitial": "W"
}, {
    "cityCode": "371000",
    "cityName": "威海市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734037103099905",
    "countyCode": null,
    "regionNamePinyin": "weihaishi",
    "regionNameInitial": "W"
}, {
    "cityCode": "420100",
    "cityName": "武汉市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734096423141378",
    "countyCode": null,
    "regionNamePinyin": "wuhanshi",
    "regionNameInitial": "W"
}, {
    "cityCode": "450400",
    "cityName": "梧州市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130733973777498113",
    "countyCode": null,
    "regionNamePinyin": "wuzhoushi",
    "regionNameInitial": "W"
}, {
    "cityCode": "469001",
    "cityName": "五指山市",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733975400693761",
    "countyCode": null,
    "regionNamePinyin": "wuzhishanshi",
    "regionNameInitial": "W"
}, {
    "cityCode": "469005",
    "cityName": "文昌市",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733975316807682",
    "countyCode": null,
    "regionNamePinyin": "wenchangshi",
    "regionNameInitial": "W"
}, {
    "cityCode": "469006",
    "cityName": "万宁市",
    "provinceCode": "460000",
    "provinceName": "海南省",
    "id": "1130733975291641857",
    "countyCode": null,
    "regionNamePinyin": "wanningshi",
    "regionNameInitial": "W"
}, {
    "cityCode": "532600",
    "cityName": "文山壮族苗族自治州",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130734042467614721",
    "countyCode": null,
    "regionNamePinyin": "wenshanzhuangzumiaozuzizhizhou",
    "regionNameInitial": "W"
}, {
    "cityCode": "610500",
    "cityName": "渭南市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130734038860513281",
    "countyCode": null,
    "regionNamePinyin": "weinanshi",
    "regionNameInitial": "W"
}, {
    "cityCode": "620600",
    "cityName": "武威市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130734072461082626",
    "countyCode": null,
    "regionNamePinyin": "wuweishi",
    "regionNameInitial": "W"
}, {
    "cityCode": "640300",
    "cityName": "吴忠市",
    "provinceCode": "640000",
    "provinceName": "宁夏回族自治区",
    "id": "1130734043654602753",
    "countyCode": null,
    "regionNamePinyin": "wuzhongshi",
    "regionNameInitial": "W"
}, {
    "cityCode": "650100",
    "cityName": "乌鲁木齐市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130733959760134146",
    "countyCode": null,
    "regionNamePinyin": "wulumuqishi",
    "regionNameInitial": "W"
}, {
    "cityCode": "659004",
    "cityName": "五家渠市",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734022871826438",
    "countyCode": null,
    "regionNamePinyin": "wujiaqushi",
    "regionNameInitial": "W"
}]], ["X", [{
    "cityCode": "130500",
    "cityName": "邢台市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130734069051113474",
    "countyCode": null,
    "regionNamePinyin": "xingtaishi",
    "regionNameInitial": "X"
}, {
    "cityCode": "140900",
    "cityName": "忻州市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130734097241030658",
    "countyCode": null,
    "regionNamePinyin": "xinzhoushi",
    "regionNameInitial": "X"
}, {
    "cityCode": "152200",
    "cityName": "兴安盟",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130733987203465218",
    "countyCode": null,
    "regionNamePinyin": "xinganmeng",
    "regionNameInitial": "X"
}, {
    "cityCode": "152500",
    "cityName": "锡林郭勒盟",
    "provinceCode": "150000",
    "provinceName": "内蒙古自治区",
    "id": "1130734015217221634",
    "countyCode": null,
    "regionNamePinyin": "xilinguolemeng",
    "regionNameInitial": "X"
}, {
    "cityCode": "320300",
    "cityName": "徐州市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734043134509057",
    "countyCode": null,
    "regionNamePinyin": "xuzhoushi",
    "regionNameInitial": "X"
}, {
    "cityCode": "341800",
    "cityName": "宣城市",
    "provinceCode": "340000",
    "provinceName": "安徽省",
    "id": "1130734071928406018",
    "countyCode": null,
    "regionNamePinyin": "xuanchengshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "350200",
    "cityName": "厦门市",
    "provinceCode": "350000",
    "provinceName": "福建省",
    "id": "1130733974821879809",
    "countyCode": null,
    "regionNamePinyin": "xiamenshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "360500",
    "cityName": "新余市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130733967783837698",
    "countyCode": null,
    "regionNamePinyin": "xinyushi",
    "regionNameInitial": "X"
}, {
    "cityCode": "410700",
    "cityName": "新乡市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734099686309889",
    "countyCode": null,
    "regionNamePinyin": "xinxiangshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "411000",
    "cityName": "许昌市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734094678310913",
    "countyCode": null,
    "regionNamePinyin": "xuchangshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "411500",
    "cityName": "信阳市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130733991179665409",
    "countyCode": null,
    "regionNamePinyin": "xinyangshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "420600",
    "cityName": "襄阳市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130733966504574977",
    "countyCode": null,
    "regionNamePinyin": "xiangyangshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "420900",
    "cityName": "孝感市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734103591206913",
    "countyCode": null,
    "regionNamePinyin": "xiaoganshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "421200",
    "cityName": "咸宁市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130733980773597186",
    "countyCode": null,
    "regionNamePinyin": "xianningshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "429004",
    "cityName": "仙桃市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130733964382257153",
    "countyCode": null,
    "regionNamePinyin": "xiantaoshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "430300",
    "cityName": "湘潭市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130734100801994754",
    "countyCode": null,
    "regionNamePinyin": "xiangtanshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "433100",
    "cityName": "湘西土家族苗族自治州",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130733961546907649",
    "countyCode": null,
    "regionNamePinyin": "xiangxitujiazumiaozuzizhizhou",
    "regionNameInitial": "X"
}, {
    "cityCode": "532800",
    "cityName": "西双版纳傣族自治州",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130733987820027905",
    "countyCode": null,
    "regionNamePinyin": "xishuangbannadaizuzizhizhou",
    "regionNameInitial": "X"
}, {
    "cityCode": "610100",
    "cityName": "西安市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130734101707964418",
    "countyCode": null,
    "regionNamePinyin": "xianshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "610400",
    "cityName": "咸阳市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130734061987905537",
    "countyCode": null,
    "regionNamePinyin": "xianyangshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "630100",
    "cityName": "西宁市",
    "provinceCode": "630000",
    "provinceName": "青海省",
    "id": "1130734046460592129",
    "countyCode": null,
    "regionNamePinyin": "xiningshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "710200",
    "cityName": "新北市",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734101510832130",
    "countyCode": null,
    "regionNamePinyin": "xinbeishi",
    "regionNameInitial": "X"
}, {
    "cityCode": "710800",
    "cityName": "新竹市",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734062944206850",
    "countyCode": null,
    "regionNamePinyin": "xinzhushi",
    "regionNameInitial": "X"
}, {
    "cityCode": "719002",
    "cityName": "新竹县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734022590808071",
    "countyCode": null,
    "regionNamePinyin": "xinzhuxian",
    "regionNameInitial": "X"
}, {
    "cityCode": "810000",
    "cityName": "香港特别行政区",
    "provinceCode": "810000",
    "provinceName": "香港特别行政区",
    "id": "1130734001619288065",
    "countyCode": null,
    "regionNamePinyin": "xianggangtebiexingzhengqu",
    "regionNameInitial": "X"
}]], ["Y", [{
    "cityCode": "140300",
    "cityName": "阳泉市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130733982342266882",
    "countyCode": null,
    "regionNamePinyin": "yangquanshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "140800",
    "cityName": "运城市",
    "provinceCode": "140000",
    "provinceName": "山西省",
    "id": "1130734044048867329",
    "countyCode": null,
    "regionNamePinyin": "yunchengshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "210800",
    "cityName": "营口市",
    "provinceCode": "210000",
    "provinceName": "辽宁省",
    "id": "1130733962708729857",
    "countyCode": null,
    "regionNamePinyin": "yingkoushi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "222400",
    "cityName": "延边朝鲜族自治州",
    "provinceCode": "220000",
    "provinceName": "吉林省",
    "id": "1130734058846371842",
    "countyCode": null,
    "regionNamePinyin": "yanbianchaoxianzuzizhizhou",
    "regionNameInitial": "Y"
}, {
    "cityCode": "230700",
    "cityName": "伊春市",
    "provinceCode": "230000",
    "provinceName": "黑龙江省",
    "id": "1130734095634612226",
    "countyCode": null,
    "regionNamePinyin": "yichunshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "320900",
    "cityName": "盐城市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734070590423042",
    "countyCode": null,
    "regionNamePinyin": "yanchengshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "321000",
    "cityName": "扬州市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130733986536570882",
    "countyCode": null,
    "regionNamePinyin": "yangzhoushi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "360600",
    "cityName": "鹰潭市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130733982497456129",
    "countyCode": null,
    "regionNamePinyin": "yingtanshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "360900",
    "cityName": "宜春市",
    "provinceCode": "360000",
    "provinceName": "江西省",
    "id": "1130734046175379458",
    "countyCode": null,
    "regionNamePinyin": "yichunshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "370600",
    "cityName": "烟台市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734013568860161",
    "countyCode": null,
    "regionNamePinyin": "yantaishi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "420500",
    "cityName": "宜昌市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734024746680322",
    "countyCode": null,
    "regionNamePinyin": "yichangshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "430600",
    "cityName": "岳阳市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130733994501554178",
    "countyCode": null,
    "regionNamePinyin": "yueyangshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "430900",
    "cityName": "益阳市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130733988197515266",
    "countyCode": null,
    "regionNamePinyin": "yiyangshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "431100",
    "cityName": "永州市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130733991347437569",
    "countyCode": null,
    "regionNamePinyin": "yongzhoushi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "441700",
    "cityName": "阳江市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734091972984834",
    "countyCode": null,
    "regionNamePinyin": "yangjiangshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "445300",
    "cityName": "云浮市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734077406167041",
    "countyCode": null,
    "regionNamePinyin": "yunfushi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "450900",
    "cityName": "玉林市",
    "provinceCode": "450000",
    "provinceName": "广西壮族自治区",
    "id": "1130734045172940802",
    "countyCode": null,
    "regionNamePinyin": "yulinshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "511500",
    "cityName": "宜宾市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734075250294785",
    "countyCode": null,
    "regionNamePinyin": "yibinshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "511800",
    "cityName": "雅安市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130733994895818754",
    "countyCode": null,
    "regionNamePinyin": "yaanshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "530400",
    "cityName": "玉溪市",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130734105881296897",
    "countyCode": null,
    "regionNamePinyin": "yuxishi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "610600",
    "cityName": "延安市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130734014906843138",
    "countyCode": null,
    "regionNamePinyin": "yananshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "610800",
    "cityName": "榆林市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130733983101435906",
    "countyCode": null,
    "regionNamePinyin": "yulinshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "632700",
    "cityName": "玉树藏族自治州",
    "provinceCode": "630000",
    "provinceName": "青海省",
    "id": "1130734044136947713",
    "countyCode": null,
    "regionNamePinyin": "yushucangzuzizhizhou",
    "regionNameInitial": "Y"
}, {
    "cityCode": "640100",
    "cityName": "银川市",
    "provinceCode": "640000",
    "provinceName": "宁夏回族自治区",
    "id": "1130734077624270850",
    "countyCode": null,
    "regionNamePinyin": "yinchuanshi",
    "regionNameInitial": "Y"
}, {
    "cityCode": "654000",
    "cityName": "伊犁哈萨克自治州",
    "provinceCode": "650000",
    "provinceName": "新疆维吾尔自治区",
    "id": "1130734063925673985",
    "countyCode": null,
    "regionNamePinyin": "yilihasakezizhizhou",
    "regionNameInitial": "Y"
}, {
    "cityCode": "719001",
    "cityName": "宜兰县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734022590808072",
    "countyCode": null,
    "regionNamePinyin": "yilanxian",
    "regionNameInitial": "Y"
}, {
    "cityCode": "719007",
    "cityName": "云林县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734022871826436",
    "countyCode": null,
    "regionNamePinyin": "yunlinxian",
    "regionNameInitial": "Y"
}]], ["Z", [{
    "cityCode": "130700",
    "cityName": "张家口市",
    "provinceCode": "130000",
    "provinceName": "河北省",
    "id": "1130734101057847298",
    "countyCode": null,
    "regionNamePinyin": "zhangjiakoushi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "321100",
    "cityName": "镇江市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734093331939329",
    "countyCode": null,
    "regionNamePinyin": "zhenjiangshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "330900",
    "cityName": "舟山市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130734100034437122",
    "countyCode": null,
    "regionNamePinyin": "zhoushanshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "350600",
    "cityName": "漳州市",
    "provinceCode": "350000",
    "provinceName": "福建省",
    "id": "1130734100634222594",
    "countyCode": null,
    "regionNamePinyin": "zhangzhoushi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "370300",
    "cityName": "淄博市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734055398653953",
    "countyCode": null,
    "regionNamePinyin": "ziboshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "370400",
    "cityName": "枣庄市",
    "provinceCode": "370000",
    "provinceName": "山东省",
    "id": "1130734068476493826",
    "countyCode": null,
    "regionNamePinyin": "zaozhuangshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "410100",
    "cityName": "郑州市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734065456594946",
    "countyCode": null,
    "regionNamePinyin": "zhengzhoushi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "411600",
    "cityName": "周口市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130734015800229889",
    "countyCode": null,
    "regionNamePinyin": "zhoukoushi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "411700",
    "cityName": "驻马店市",
    "provinceCode": "410000",
    "provinceName": "河南省",
    "id": "1130733963925078018",
    "countyCode": null,
    "regionNamePinyin": "zhumadianshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "430200",
    "cityName": "株洲市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130734079562039298",
    "countyCode": null,
    "regionNamePinyin": "zhuzhoushi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "430800",
    "cityName": "张家界市",
    "provinceCode": "430000",
    "provinceName": "湖南省",
    "id": "1130733973274181633",
    "countyCode": null,
    "regionNamePinyin": "zhangjiajieshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "440400",
    "cityName": "珠海市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734090815356929",
    "countyCode": null,
    "regionNamePinyin": "zhuhaishi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "440800",
    "cityName": "湛江市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733997362069506",
    "countyCode": null,
    "regionNamePinyin": "zhanjiangshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "441200",
    "cityName": "肇庆市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734072595300353",
    "countyCode": null,
    "regionNamePinyin": "zhaoqingshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "442000",
    "cityName": "中山市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733962012475393",
    "countyCode": null,
    "regionNamePinyin": "zhongshanshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "510300",
    "cityName": "自贡市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734062168260610",
    "countyCode": null,
    "regionNamePinyin": "zigongshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "512000",
    "cityName": "资阳市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734044384411649",
    "countyCode": null,
    "regionNamePinyin": "ziyangshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "520300",
    "cityName": "遵义市",
    "provinceCode": "520000",
    "provinceName": "贵州省",
    "id": "1130734090681139203",
    "countyCode": null,
    "regionNamePinyin": "zunyishi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "530600",
    "cityName": "昭通市",
    "provinceCode": "530000",
    "provinceName": "云南省",
    "id": "1130734076349202434",
    "countyCode": null,
    "regionNamePinyin": "zhaotongshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "620700",
    "cityName": "张掖市",
    "provinceCode": "620000",
    "provinceName": "甘肃省",
    "id": "1130734058254974978",
    "countyCode": null,
    "regionNamePinyin": "zhangyeshi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "640500",
    "cityName": "中卫市",
    "provinceCode": "640000",
    "provinceName": "宁夏回族自治区",
    "id": "1130733993490726914",
    "countyCode": null,
    "regionNamePinyin": "zhongweishi",
    "regionNameInitial": "Z"
}, {
    "cityCode": "719004",
    "cityName": "彰化县",
    "provinceCode": "710000",
    "provinceName": "台湾省",
    "id": "1130734022590808069",
    "countyCode": null,
    "regionNamePinyin": "zhanghuaxian",
    "regionNameInitial": "Z"
}]]];
var hotCityList = [{
    "cityCode": "110000",
    "cityName": "北京市",
    "provinceCode": "110000",
    "provinceName": "北京市",
    "id": "1130734065938939906",
    "countyCode": null,
    "regionNamePinyin": "beijingshi",
    "regionNameInitial": "B"
}, {
    "cityCode": "310000",
    "cityName": "上海市",
    "provinceCode": "310000",
    "provinceName": "上海市",
    "id": "1130733995780816897",
    "countyCode": null,
    "regionNamePinyin": "shanghaishi",
    "regionNameInitial": "S"
}, {
    "cityCode": "440100",
    "cityName": "广州市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130734026353098753",
    "countyCode": null,
    "regionNamePinyin": "guangzhoushi",
    "regionNameInitial": "G"
}, {
    "cityCode": "440300",
    "cityName": "深圳市",
    "provinceCode": "440000",
    "provinceName": "广东省",
    "id": "1130733985072758785",
    "countyCode": null,
    "regionNamePinyin": "shenzhenshi",
    "regionNameInitial": "S"
}, {
    "cityCode": "120000",
    "cityName": "天津市",
    "provinceCode": "120000",
    "provinceName": "天津市",
    "id": "1130734042702495745",
    "countyCode": null,
    "regionNamePinyin": "tianjinshi",
    "regionNameInitial": "T"
}, {
    "cityCode": "610100",
    "cityName": "西安市",
    "provinceCode": "610000",
    "provinceName": "陕西省",
    "id": "1130734101707964418",
    "countyCode": null,
    "regionNamePinyin": "xianshi",
    "regionNameInitial": "X"
}, {
    "cityCode": "500000",
    "cityName": "重庆市",
    "provinceCode": "500000",
    "provinceName": "重庆市",
    "id": "1130734043931426818",
    "countyCode": null,
    "regionNamePinyin": "chongqingshi",
    "regionNameInitial": "C"
}, {
    "cityCode": "330100",
    "cityName": "杭州市",
    "provinceCode": "330000",
    "provinceName": "浙江省",
    "id": "1130734105407340545",
    "countyCode": null,
    "regionNamePinyin": "hangzhoushi",
    "regionNameInitial": "H"
}, {
    "cityCode": "320100",
    "cityName": "南京市",
    "provinceCode": "320000",
    "provinceName": "江苏省",
    "id": "1130734076592472066",
    "countyCode": null,
    "regionNamePinyin": "nanjingshi",
    "regionNameInitial": "N"
}, {
    "cityCode": "420100",
    "cityName": "武汉市",
    "provinceCode": "420000",
    "provinceName": "湖北省",
    "id": "1130734096423141378",
    "countyCode": null,
    "regionNamePinyin": "wuhanshi",
    "regionNameInitial": "W"
}, {
    "cityCode": "510100",
    "cityName": "成都市",
    "provinceCode": "510000",
    "provinceName": "四川省",
    "id": "1130734068984004610",
    "countyCode": null,
    "regionNamePinyin": "chengdushi",
    "regionNameInitial": "C"
}];


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vuecity"}},[_c('div',{staticClass:"pattern-box"},[_c('span',{staticClass:"mapBack",on:{"click":function($event){return _vm.mapBack(null)}}},[_c('i',{class:['iconfont', _vm.backIcon],staticStyle:{"fontSize":"28px"}})]),_vm._v(" "),_c('search',{attrs:{"can-search-spell":_vm.canSearchSpell,"clear-text":_vm.clearSearch},on:{"txtdata":_vm.searchText}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"calc(100% - 45px)","width":"100%"}},[_c('transition',{attrs:{"name":"list"}},[(_vm.associationShow)?_c('search-list',{attrs:{"search-list-content":_vm.searchListContent},on:{"changeName":_vm.changeCity}}):_vm._e()],1),_vm._v(" "),_c('scroll',{ref:"suggest",attrs:{"data":_vm.citylist,"probe-type":3,"listen-scroll":true},on:{"distance":_vm.distance,"scrollStore":_vm.scrollStore}},[_c('div',[_c('div',{ref:"positionBox"}),_vm._v(" "),_c('position-box',{attrs:{"location":_vm.location,"choice-city-name":_vm.chooseCityName},on:{"changeCity":_vm.changeCity}}),_vm._v(" "),_c('city-list',{attrs:{"citylist":_vm.citylist,"hotCityList":_vm.hotCity,"element-index":_vm.elementIndex},on:{"positionCity":_vm.changeCity,"singleLetter":_vm.singleLetter}})],1)])],1),_vm._v(" "),_c('nav-list',{directives:[{name:"show",rawName:"v-show",value:(!_vm.associationShow),expression:"!associationShow"}],attrs:{"nav-list":_vm.cityIndexList,"flag-text":_vm.flagText},on:{"toElement":_vm.toElement}}),_vm._v(" "),_c('transition',{attrs:{"name":"flag"}},[(_vm.flag)?_c('div',{staticClass:"nowFlag"},[_vm._v(_vm._s(_vm.flagText))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.slideStyle}},[(_vm.showStatus)?_c('city-view',{attrs:{"hide":_vm.hide,"backStyle":_vm.backStyle,"canSearchSpell":_vm.canSearchSpell},on:{"closeChooseCity":_vm.closeChooseCity}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// best-city.js